import { yupResolver } from "@hookform/resolvers/yup";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import Moment from "moment";
import ArrowBackIos from "@mui/icons-material/ArrowBackIos";
import CancelIcon from "@mui/icons-material/Cancel";
import VerifiedIcon from "@mui/icons-material/Verified";
import {
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Link,
  Paper,
  TextField,
  Typography,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { Chip, Divider, Tooltip } from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import BadgeIcon from "@mui/icons-material/Badge";
import SchoolIcon from "@mui/icons-material/School";
import WorkHistoryIcon from "@mui/icons-material/WorkHistory";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import ArticleIcon from "@mui/icons-material/Article";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import MDButton from "components/MDButton";
import SelectDropDown from "examples/DropDown";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import {
  setCityList,
  setCompanyType,
  setDepartmentType,
  setExperience,
  setLanguageType,
  setProfessionType,
  setProfessionalRegistrationType,
  setQualificationType,
  setRoleType,
  setSpecialisationsType,
} from "layouts/events/Redux/actionCreator";
import { useEffect, useState } from "react";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getUserByIdService } from "services/userServices";
import userDetailsValidationSchema from "../../../util/validations/userDetailsValidation";
import { setProfilePhoto, updateUser } from "../Redux/actionCreator";

import SelectDropDownNew from "examples/DropDownNew";
import MultiSelectDropdown from "examples/Multi Select Dropdown";
import {
  GetAdditionalTrainingById,
  getSoftwaresList,
  setOrganizationsDropdown,
} from "layouts/common/Redux/actionCreator";
import { setDocumentType } from "layouts/events/Redux/actionCreator";
import { getDepartmentsList } from "layouts/hospital/Redux/actionCreator";
import moment from "moment";
import NestedArray1 from "./NestedArray1";
import NestedArray2 from "./NestedArray2";
import NestedArray3 from "./NestedArray3";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import CloseIcon from "@mui/icons-material/Close";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import PersonOffOutlinedIcon from "@mui/icons-material/PersonOffOutlined";
import "./styles.css";

function UserDetailByName() {
  const [dateFormat, setDateFormat] = useState();
  const [dob, setDob] = useState("");
  const ID = window.location.href.split("name")[1].split("/")[1];
  const [organisationID, setOrganisationID] = useState();
  const [file, setFile] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);

  const [responseData, setResponseData] = useState([]);

  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const [inactiveReason, setInactiveReason] = useState("");
  const [previousStatus, setPreviousStatus] = useState("");

  // console.log("responseData>>", responseData);

  const locationOptions = [
    { key: "AWS_S3", value: "AWS_S3" },
    { key: "LOCAL", value: "LOCAL" },
    { key: "SELF_HOSTED", value: "SELF_HOSTED" },
    { key: "CLOUDINARY", value: "CLOUDINARY" },
  ];
  const getData = async () => {
    let response = await getUserByIdService(ID);

    // console.log("getData", response[0]);

    setResponseData(response[0]);
    return response[0];
  };

  const getDataForProfile = async () => {
    const res = await getUserByIdService(ID);

    setDateFormat(res[0]?.profile?.dob);
    if (res[0]?.profile?.dob == undefined) setDob("");
    else getDobb(res[0]?.profile?.dob);
  };
  const getDobb = (dateFormatt) => {
    var a, b, c;

    var dayy = new Date(dateFormatt);

    a = dayy.getDate();
    b = dayy.getMonth();
    c = dayy.getFullYear();
    setDob(a + "/" + b + "/" + c);
  };

  useEffect(() => {
    getDataForProfile();
  }, []);

  useEffect(() => {
    if (file != null) {
      dispatch(setProfilePhoto(file));
    }
  }, [file]);

  const { OrganizationsData } = useSelector((state) => state.common);
  const organizationInfo = OrganizationsData?.organizationsInfo;
  const organizationOptions = [];

  const { SoftwaresData } = useSelector((state) => state.common);
  const workedonInfo = SoftwaresData?.softwaresInfo;

  const workedonOptions = [];

  const { Additional_Id_Data } = useSelector((state) => state.common);
  const additionaTrainingInfo = Additional_Id_Data?.additionalIdInfo;

  const additionalTrainingOptions = [];
  var languageKnownIDPayload = [];

  additionaTrainingInfo.map((ele) => {
    let obj = {
      key: ele._id,
      value: ele.name,
    };

    additionalTrainingOptions.push(obj);
  });

  workedonInfo.map((ele) => {
    let obj = {
      key: ele._id,
      value: ele.name,
    };

    workedonOptions.push(obj);
  });

  organizationInfo.map((ele) => {
    let obj = {
      key: ele._id,
      value: ele.name,
    };

    organizationOptions.push(obj);
  });

  const handleOrganizationChange = (e) => {
    let orgID;
    setValue("organization.name", e.target.value);
    //Searching for the name in the Users array to find the ID
    organizationOptions.map((obj) => {
      if (obj.value == e.target.value) {
        orgID = obj.value;
      }
    });

    setOrganisationID(orgID);
  };
  //MULTI SELECT language known HANDLE SELECT
  const handleLanguageKnown = (values) => {
    //Searching for the name in the language array to find the ID

    let selectedValues = values;

    if (selectedValues) {
      selectedValues?.map((value) => {
        languageOptions?.map((obj) => {
          if (obj.value == value) {
            languageKnownIDPayload.push(obj.key);
          }
        });
      });
    }
  };

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(userDetailsValidationSchema),
    mode: "onChange",
    defaultValues: async () => await getData(),
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const temp = getValues();
  // console.log("All data", temp)
  //Hanlde Download

  //Download Function
  // function handleDownload(filename, url, extension) {
  //   const loadingTost = toast.loading("Downloading", { position: "top-right" });
  //   fetch(`https:${url}`)
  //     .then((value) => {
  //       return value.blob();
  //     })
  //     .then((value) => {
  //       toast.dismiss(loadingTost);
  //       const a = document.createElement("a");
  //       const url = window.URL.createObjectURL(value);
  //       a.href = url;

  //       a.download = `${filename}.${extension}`;
  //       a.click();
  //       toast.success("Downloaded", { position: "top-right" });
  //     });
  // }

  function handleDownload(filename, url, extension) {
    const loadingToast = toast.loading("Downloading", {
      position: "top-right",
    });

    const finalUrl = url.startsWith("http") ? url : `https:${url}`;
    console.log("finalUrl", finalUrl)

    fetch(finalUrl)
      .then((res) => res.blob())
      .then((blob) => {
        toast.dismiss(loadingToast);

        const a = document.createElement("a");
        const objectUrl = window.URL.createObjectURL(blob);

        a.href = objectUrl;
        a.download = `${filename}.${extension}`;
        a.click();

        window.URL.revokeObjectURL(objectUrl);

        toast.success("Downloaded", {
          position: "top-right",
        });
      })
      .catch((error) => {
        console.error("Download error:", error);
        toast.dismiss(loadingToast);
        toast.error("Download failed");
      });
  }

  const handleVerifiedDocument = (url) => {
    if (!url) {
      return toast.error("Document not available");
    }

    const finalUrl = url.startsWith("http") ? url : `https:${url}`;

    window.open(finalUrl, "_blank", "noopener,noreferrer");
  };

  //Finding USER Object
  const { Users_Data, User_profile_image_Data } = useSelector(
    (state) => state.user,
  );
  const profileImageInfo = User_profile_image_Data?.User_profile_image_info;
  const users = Users_Data.Users_DataInfo;

  var userObj;
  users.map((user) => {
    if (user._id == ID) {
      userObj = user;
    }
  });

  const onSubmit = (data) => {
    // console.log("data>>>", data);
    // if (!data.organizations?.[0]?.isOwner) {
    //   toast.error("First organization must be marked as Owner");
    //   return;
    // }
    const organization = [];
    data?.organizations.map((ele) => {
      let obj = {
        role:
          typeof ele?.role == "object"
            ? ele?.role?._id
              ? ele?.role?._id
              : ""
            : ele?.role,
        organization:
          typeof ele?.organization == "object"
            ? ele?.organization?._id
              ? ele?.organization?._id
              : ""
            : ele?.organization,
        isOwner: ele?.isOwner,
        isWhatsappBotEnabled: ele?.isWhatsappBotEnabled,
      };
      organization.push(obj);
    });
    let departmentsArray = [];
    data.departments.map((obj) => {
      departmentsArray.push(obj._id);
    });

    let educationPayload = [];
    let jobHistoryPayload = [];

    //Job History Payload
    data?.profile?.jobHistory.map((obj) => {
      let tempObjJobHistory = {
        employmentLetter: {
          docType: "",
          files: "",
        },
        salarySlip: {
          docType: "",
          files: "",
        },
        isCurrent: "",
        hospital: "",
        department: "",
        specialisation: "",
        start: "",
        end: "",
        _id: "",
      };

      tempObjJobHistory.employmentLetter.docType =
        typeof obj?.employmentLetter.docType == "object"
          ? obj?.employmentLetter.docType?._id
            ? obj?.employmentLetter.docType?._id
            : ""
          : obj?.employmentLetter.docType;

      tempObjJobHistory.employmentLetter.files = obj?.employmentLetter?.files;
      //Salary Slip
      tempObjJobHistory.salarySlip.docType =
        typeof obj?.salarySlip.docType == "object"
          ? obj?.salarySlip.docType?._id
            ? obj?.salarySlip.docType?._id
            : ""
          : obj?.salarySlip.docType;

      tempObjJobHistory.salarySlip.files = obj?.salarySlip?.files;
      tempObjJobHistory.isCurrent = obj?.isCurrent;
      tempObjJobHistory.hospital = obj?.hospital;
      tempObjJobHistory.department =
        typeof obj?.department == "object"
          ? obj?.department?._id
            ? obj?.department?._id
            : ""
          : obj?.department;

      tempObjJobHistory.specialisation =
        typeof obj?.specialisation == "object"
          ? obj?.specialisation?._id
            ? obj?.specialisation?._id
            : ""
          : obj?.specialisation;

      tempObjJobHistory.start = obj?.start;
      tempObjJobHistory.end = obj?.end;
      tempObjJobHistory._id = obj?._id;

      jobHistoryPayload.push(tempObjJobHistory);
    });

    let tempObjJobHistory = {
      employmentLetter: {
        docType: "",
        files: "",
      },
      salarySlip: {
        docType: "",
        files: "",
      },
      isCurrent: "",
      hospital: "",
      department: "",
      specialisation: "",
      start: "",
      end: "",
      _id: "",
    };

    //Looping through Education
    data?.profile?.education.map((obj) => {
      let tempObj = {
        certificate: {
          docType: "",
          files: "",
          uploadedAt: "",
        },
        isForeign: "",
        specialisation: "",
        name: "",
        year: "",
        _id: "",
        course: "",
      };

      tempObj.certificate.docType =
        typeof obj?.certificate.docType == "object"
          ? obj?.certificate.docType?._id
            ? obj?.certificate.docType?._id
            : ""
          : obj?.certificate.docType;

      tempObj.certificate.files = obj?.certificate?.files;
      tempObj.certificate.uploadedAt = obj?.certificate?.uploadedAt;
      tempObj.isForeign = obj?.isForeign;
      tempObj.name = obj?.name;
      tempObj.specialisation =
        typeof obj?.specialisation == "object"
          ? obj?.specialisation?._id
            ? obj?.specialisation?._id
            : ""
          : obj?.specialisation;

      tempObj._id = obj?._id;
      tempObj.year = obj?.year;
      tempObj.course = obj?.course;

      educationPayload.push(tempObj);
    });

    var ProfileDob = [];
    var dobj;
    if (data?.profile?.dob?.length !== undefined) {
      if (data?.profile?.dob !== "") {
        ProfileDob = data?.profile?.dob.split("/");

        dobj = new Date(
          parseInt(ProfileDob[2]),
          parseInt(ProfileDob[1]) - 1,
          parseInt(ProfileDob[0]) + 1,
        )?.toISOString();
      }
    }

    const orgIndexForWhatsapp = data.orgIndex;

    let payload = {
      name: {
        salutation: data?.name?.salutation,
        first: data?.name?.first,
        middle: data?.name?.middle,
        last: data?.name?.last,
        full: data?.name?.full,
      },
      enabled: data?.enabled ? data?.enabled : false,
      _id: data?._id,
      emails: data?.emails,
      phoneNumbers: data?.phoneNumbers,
      password: data?.password,

      avatar: profileImageInfo[0] ? profileImageInfo[0] : data.avatar,

      correspondenceAddress: {
        address: data?.correspondenceAddress?.address,
        city: data?.correspondenceAddress?.city,
        state: data?.correspondenceAddress?.state,
        pin: data?.correspondenceAddress?.pin,
        country: data?.correspondenceAddress?.country,
        coords: data?.correspondenceAddress?.coords,
      },

      profile: {
        social: {
          facebook: data?.profile?.social?.facebook,
          linkedin: data?.profile?.social?.linkedin,
        },
        dob: dobj,
        currentlyEmployed: data?.profile?.currentlyEmployed,
        gender: data?.profile?.gender,
        pan: data?.profile?.pan,
        aadhar: data?.profile?.aadhar,
        covid: data?.profile?.covid,

        jobHistory: jobHistoryPayload,
        education: educationPayload,
        references: data?.profile?.references,
      },

      organizations: organization,
      __v: data?._v,

      progress: data?.progress,

      email: data?.email,
      phoneNumber: data?.phoneNumber,

      //profile photo url
      role: role,
      canAccessKeystone: data?.canAccessKeystone,
      // profilePhotoIsSecured:data?.profilePhotoIsSecured,
      status: data?.status,
      address: {
        address: data?.address?.address,
        city: data?.address?.city,
        state: data?.address?.state,
        pin: data?.address?.pin,
        country: data?.address?.country,
      },
      numExperience: exp,
      qualification: qual,

      professionalRegistration: {
        registrationType: proReg,
      },
      languageKnown: data?.languageKnown ? data?.languageKnown : "NA",
      languageKnownNew: Array.isArray(data?.languageKnownNew)
        ? data.languageKnownNew
        : typeof data?.languageKnownNew === "string"
          ? data.languageKnownNew.split(",").map((lang) => lang.trim())
          : ["NA"],
      // languageKnownNew: Array.isArray(data?.languageKnownNew) ? data?.languageKnownNew : ["NA"],

      // languageKnown:
      //   languageKnownIDPayload?.length > 0
      //     ? languageKnownIDPayload
      //     : data?.languageKnown.map((obj) => obj?._id),
      departments:
        deaprtmentsIDPayload?.length > 0
          ? deaprtmentsIDPayload
          : data?.departments.map((obj) => obj?._id),
      workCity: city,
      specialization: special,
      professionalType: proType,
      workedOn:
        workedOnIDPayload?.length > 0
          ? workedOnIDPayload
          : data?.workedOn.map((obj) => obj?._id),
      additionalTraining: data?.additionalTraining
        ? data?.additionalTraining
        : "NA",
      // additionalTrainingNew: data?.additionalTrainingNew ? data.additionalTrainingNew.split(',').map(lang => lang.trim()) : ["NA"],
      additionalTrainingNew: Array.isArray(data?.additionalTrainingNew)
        ? data.additionalTrainingNew
        : typeof data?.additionalTrainingNew === "string"
          ? data.additionalTrainingNew.split(",").map((lang) => lang.trim())
          : ["NA"],
      // additionalTraining:
      //   additionalTrainingIDPayload?.length > 0
      //     ? additionalTrainingIDPayload
      //     : data?.additionalTraining.map((obj) => obj?._id),
      bankDetails: {
        accountNumber: data?.bankDetails?.accountNumber,
        bankName: data?.bankDetails?.bankName,
        benifeciaryName: data?.bankDetails?.beneficiaryName,
        branchAddress: data?.bankDetails?.branchAddress,
        ifsc: data?.bankDetails?.ifsc,
      },
      inactiveReason: data?.inactiveReason,
      // orgIndex: orgIndexForWhatsapp >= 0 ? orgIndexForWhatsapp : undefined,
    };
    // console.log("payload>>", payload);
    dispatch(updateUser({ payload: payload, id: ID })).then(() => {
      navigate("/users");
    });
  };

  const {
    City_List_Data,
    Company_Type_Data,
    Experience_Data,
    Profession_Type_Data,
    Qualification_Type_Data,
    Specialization_Type_Data,
    Department_Type_Data,
    Role_Type_Data,
    Language_Type_Data,
    Professional_Registration_Type_Data,
    Document_Type_Data,
  } = useSelector((state) => state.events);

  const cityData = City_List_Data.cityListInfo;
  const employerData = Company_Type_Data.companyTypeInfo;
  const experienceData = Experience_Data.experienceInfo;
  const professionData = Profession_Type_Data.professionInfo;
  const qualificationsData = Qualification_Type_Data.qualificationInfo;
  const specializationsData = Specialization_Type_Data.specializationInfo;
  const departmentData = Department_Type_Data.departmentInfo;

  const roleData = Role_Type_Data.roleInfo;
  const languageData = Language_Type_Data.languageInfo;
  const professionalRegistrationTypeData =
    Professional_Registration_Type_Data.professionInfo;
  const documentTypeData = Document_Type_Data.documentTypeInfo;
  const { documentTypeDropDown } = useSelector((state) => state.hospital);
  const docTypeData = documentTypeDropDown?.documentTypeDropDownInfo;
  const docTypeOptions = [];

  const { hospital_department_Data, hospital_branch_Data } = useSelector(
    (state) => state.hospital,
  );
  const department_Info = hospital_department_Data?.departmentInfo;

  documentTypeData.map((ele) => {
    let obj = {
      key: ele._id,
      value: ele.name,
    };

    docTypeOptions.push(obj);
  });

  //Drop Down Options
  const cityOptions = [];
  const employerTypeOptions = [];
  const experienceOptions = [];
  const professionOptions = [];
  const qualificationOptions = [];
  const specializationOptions = [];
  const departmentOptions = [];
  const roleOptions = [];
  const languageOptions = [];
  const professionalRegistrationTypeOptions = [];
  const documentTypeOptions = [];
  const departmentTypeOption = [];
  documentTypeData.map((ele) => {
    let obj = {
      key: ele._id,
      value: ele.name,
    };

    documentTypeOptions.push(obj);
  });

  departmentData.map((elem) => {
    let obj = {
      key: elem?._id,
      value: elem?.name,
    };
    departmentTypeOption.push(obj);
  });

  // departmentData.map((ele) => {
  //   let obj = {
  //     key: ele._id,
  //     value: ele.name,
  //   };

  //   departmentOptions.push(obj);
  // });

  department_Info.map((ele) => {
    let obj = {
      key: ele._id,
      value: ele.name,
    };

    departmentOptions.push(obj);
  });

  roleData.map((ele) => {
    let obj = {
      key: ele._id,
      value: ele.name,
    };

    roleOptions.push(obj);
  });

  languageData.map((ele) => {
    let obj = {
      key: ele._id,
      value: ele.name,
    };

    languageOptions.push(obj);
  });

  professionalRegistrationTypeData &&
    professionalRegistrationTypeData.map((ele) => {
      let obj = {
        key: ele._id,
        value: ele.name,
      };
      professionalRegistrationTypeOptions.push(obj);
    });

  cityData.map((ele) => {
    let obj = {
      key: ele._id,
      value: ele.name,
    };

    cityOptions.push(obj);
  });
  employerData.map((ele) => {
    let obj = {
      key: ele._id,
      value: ele.name,
    };

    employerTypeOptions.push(obj);
  });

  experienceData.map((ele) => {
    let obj = {
      key: ele._id,
      value: ele.name,
    };

    experienceOptions.push(obj);
  });

  professionData.map((ele) => {
    let obj = {
      key: ele._id,
      value: ele.name,
    };

    professionOptions.push(obj);
  });

  qualificationsData.map((ele) => {
    let obj = {
      key: ele._id,
      value: ele.name,
    };
    qualificationOptions.push(obj);
  });

  specializationsData.map((ele) => {
    let obj = {
      key: ele._id,
      value: ele.name,
    };
    specializationOptions.push(obj);
  });

  //DropDown Options
  const selectOptions = [
    {
      key: "1",
      value: "1",
    },
    {
      key: "2",
      value: "2",
    },
  ];

  //Avatar Location
  const avatarLocationOptions = [
    {
      key: "AWS_S 3",
      value: "AWS_S 3",
    },
    {
      key: "LOCAL",
      value: "LOCAL",
    },
    {
      key: "SELF_HOSTED",
      value: "SELF_HOSTED",
    },
    {
      key: "CLOUDINARY",
      value: "CLOUDINARY",
    },
  ];

  const values = getValues();

  //Status DropDown Options
  const statusOptions = [
    { key: "ACTIVE", value: "ACTIVE" },
    { key: "INACTIVE", value: "INACTIVE" },
    { key: "SIGNUP", value: "SIGNUP" },
    { key: "BGVTRIGGERED", value: "BGVTRIGGERED" },
    { key: "BGVFAILED", value: "BGVFAILED" },
    { key: "BGVDELAYED", value: "BGVDELAYED" },
    { key: "BGVEXPIRED", value: "BGVEXPIRED" },
    { key: "", value: "" },
  ];

  const {
    fields: profileJobHistory,
    append: profileJobHistoryAppend,
    remove: profileJobHistoryRemove,
  } = useFieldArray({
    control,
    name: "profile.jobHistory",
  });

  const [salarySlip, setSalarySlip] = useState();
  const {
    fields: salaryField,
    remove: salaryRemove,
    append: salaryAppend,
  } = useFieldArray({
    control,
    name: `profile.jobHistory.[${salarySlip}].salarySlip.files`,
  });

  const [certificate, setCertificate] = useState();
  const {
    fields: CertificateField,
    remove: CertificateRemove,
    append: CertificateAppend,
  } = useFieldArray({
    control,
    name: `profile.education.[${certificate}].certificate.files`,
  });

  const [emp, setEmp] = useState();
  const {
    fields: employmentField,
    remove: employmentRemove,
    append: employmentAppend,
  } = useFieldArray({
    control,
    name: `profile.jobHistory.[${emp}].employmentLetter.files`,
  });

  const {
    fields: profileRefrence,
    append: profileRefrenceAppend,
    remove: profileRefrenceRemove,
  } = useFieldArray({
    control,
    name: "profile.references",
  });

  const {
    fields: Address,
    append: addressAppend,
    remove: addressRemove,
  } = useFieldArray({
    control,
    name: "Address",
  });

  const {
    fields: documents,
    append: documentsAppend,
    remove: documentsRemove,
  } = useFieldArray({
    control,
    name: "documents",
  });

  const {
    fields: organizations,
    append: companyAppend,
    remove: companyRemove,
  } = useFieldArray({
    control,
    name: "organizations",
  });

  const {
    fields: correspondenceAddress,
    append: correspondenceAppend,
    remove: correspondenceRemove,
  } = useFieldArray({
    control,
    name: "correspondenceAddress",
  });

  const {
    fields: profileEducation,
    append: profileEducationAppend,
    remove: profileEducationRemove,
  } = useFieldArray({
    control,
    name: "profile.education",
  });

  const [additionall, setAdditional] = useState("");

  var additionalTrainingIDPayload = [];

  const handleAdditionalTraining = (values) => {
    additionalTrainingIDPayload = [];
    let selectedValues = values;
    if (selectedValues) {
      selectedValues?.map((value) => {
        additionalTrainingOptions?.map((obj) => {
          if (obj.value == value) {
            additionalTrainingIDPayload.push(obj.key);
          }
        });
      });
    }
  };

  const [role, setRole] = useState("");
  const handleRole = (e) => {
    let userID;

    roleOptions.map((obj) => {
      if (obj.value == e.target.value) {
        userID = obj.key;
      }
    });

    setRole(userID);
  };
  const [exp, setExp] = useState("");
  const handleExperience = (e) => {
    let userID;
    // setValue(`additionalTraining[0].name`,e.target.value)
    experienceOptions.map((obj) => {
      if (obj.value == e.target.value) {
        userID = obj.key;
      }
    });

    setExp(userID);
  };

  const [qual, setQual] = useState("");
  const handleQualification = (e) => {
    let userID;
    // setValue(`additionalTraining[0].name`,e.target.value)
    qualificationOptions.map((obj) => {
      if (obj.value == e.target.value) {
        userID = obj.key;
      }
    });

    setQual(userID);
  };

  const handleDocTypeChange = (e, name) => {
    let docTypeID;
    // setValue(`additionalTraining[0].name`,e.target.value)
    documentTypeOptions.map((obj) => {
      if (obj.value == e.target.value) {
        docTypeID = obj.key;
      }
    });

    setValue(name, docTypeID);
  };

  const handleSpecializationDynamic = (e, name) => {
    let specializationID;

    specializationOptions.map((obj) => {
      if (obj.value == e.target.value) {
        specializationID = obj.key;
      }
    });
    setValue(name, specializationID);
  };

  const [proReg, setProReg] = useState("");
  const handleProfessionalReg = (e) => {
    let userID;
    // setValue(`professionalRegistration.registrationType.name`,e.target.value)
    professionalRegistrationTypeOptions.map((obj) => {
      if (obj.value == e.target.value) {
        userID = obj.key;
      }
    });

    setProReg(userID);
  };

  const [proType, setProType] = useState("");
  const handleProfessionalType = (e) => {
    let userID;
    setValue(`professionalType.name`, e.target.value);
    professionOptions.map((obj) => {
      if (obj.value == e.target.value) {
        userID = obj.key;
      }
    });

    setProType(userID);
  };
  const [special, setSpecial] = useState("");

  const handleSpecialization = (e) => {
    let userID;
    setValue(`specialization.name`, e.target.value);
    specializationOptions.map((obj) => {
      if (obj.value == e.target.value) {
        userID = obj.key;
      }
    });

    setSpecial(userID);
  };

  const [dprt, setDprt] = useState("");
  const handleDepartments = (e) => {
    setValue(`departments[0].name`, e.target.value);
    let userID;

    departmentTypeOption.map((obj) => {
      if (obj.value == e.target.value) {
        userID = obj.key;
      }
    });

    setDprt(userID);
  };

  const [city, setCity] = useState("");
  const handleWorkCity = (e) => {
    setValue(`workCity.name`, e.target.value);
    let userID;

    cityOptions.map((obj) => {
      if (obj.value == e.target.value) {
        userID = obj.key;
      }
    });

    setCity(userID);
  };
  const [lang, setLang] = useState("");
  const handleLanguage = (e) => {
    setValue(`languageKnown[0].name`, e.target.value);
    setValue(`languageKnownNew[0].name`, e.target.value);
    let userID;

    languageOptions.map((obj) => {
      if (obj.value == e.target.value) {
        userID = obj.key;
      }
    });

    setLang(userID);
  };

  const [worked, setWorked] = useState("");
  var workedOnIDPayload = [];

  const handleWorked = (values) => {
    workedOnIDPayload = [];
    let selectedValues = values;
    if (selectedValues) {
      selectedValues?.map((value) => {
        workedonOptions?.map((obj) => {
          if (obj.value == value) {
            workedOnIDPayload.push(obj.key);
          }
        });
      });
    }
  };

  var deaprtmentsIDPayload = [];

  const handleDepartmentMultiSelect = (values) => {
    deaprtmentsIDPayload = [];
    let selectedValues = values;
    if (selectedValues) {
      selectedValues?.map((value) => {
        departmentTypeOption?.map((obj) => {
          if (obj.value == value) {
            deaprtmentsIDPayload.push(obj.key);
          }
        });
      });
    }
  };

  const {
    fields: email,
    append: emailAppend,
    remove: emailRemove,
  } = useFieldArray({
    control,
    name: "emails",
  });
  const {
    fields: organization,
    append: organizationAppend,
    remove: organizationRemove,
  } = useFieldArray({
    control,
    name: "organizations",
  });

  const {
    fields: phone,
    append: phoneAppend,
    remove: phoneRemove,
  } = useFieldArray({
    control,
    name: "phoneNumbers",
  });
  const handleBack = () => {
    navigate(-1);
  };
  const onKeyDown = (e) => {
    e.preventDefault();
  };
  useEffect(() => {
    dispatch(setOrganizationsDropdown());
    dispatch(setCityList());
    dispatch(setCompanyType());
    dispatch(setExperience());
    dispatch(setProfessionType());
    dispatch(setQualificationType());
    dispatch(setSpecialisationsType());
    dispatch(setDepartmentType());
    dispatch(setRoleType());
    dispatch(setLanguageType());
    dispatch(setProfessionalRegistrationType());
    dispatch(getSoftwaresList());
    dispatch(GetAdditionalTrainingById());
    dispatch(getDepartmentsList({}));
    dispatch(setDocumentType());
  }, []);

  const [updated1, setUpdated1] = useState(false);
  const [updated2, setUpdated2] = useState(false);
  const [updated3, setUpdated3] = useState(false);
  const [updated4, setUpdated4] = useState(false);
  const [updated5, setUpdated5] = useState(false);
  const [updated6, setUpdated6] = useState(false);
  const [arrData, setArrData] = useState([]);
  useEffect(() => {
    let createdDate = getValues("created_at");
    let updatedDate = getValues("updated_at");
    let profileDob = getValues("profile.dob");
    let regdate = getValues("professionalRegistration.registrationDate.ts");
    let expirydate = getValues("professionalRegistration.expiryDate.ts");

    // let profile=getValues("profile.jobHistory[0].employmentLetter.files[0].location");
    let profile1 = getValues("profile.jobHistory");
    if (createdDate == "Invalid date") {
      setValue("created_at", "");
    }
    if (updatedDate == "Invalid date") {
      setValue("updated_at", "");
    }
    setArrData(profile1);

    if (expirydate == "Invalid date") {
      setValue("professionalRegistration.expiryDate.ts", "");
    }

    if (expirydate !== undefined && expirydate !== "" && expirydate !== null) {
      if (!updated6) {
        const a = Moment(parseInt(expirydate)).format("DD/MM/YYYY");

        setValue("professionalRegistration.expiryDate.ts", a);
        setUpdated6(true);
      }
    }
    if (regdate == "Invalid date") {
      setValue("professionalRegistration.registrationDate.ts", "");
    }
    if (regdate !== undefined && regdate !== "" && regdate !== null) {
      if (!updated5) {
        const a = Moment(parseInt(regdate)).format("DD/MM/YYYY");

        setValue("professionalRegistration.registrationDate.ts", a);
        setUpdated5(true);
      }
    }
    if (createdDate != undefined && createdDate !== "") {
      if (!updated1) {
        const a = Moment(createdDate).format("DD/MM/YYYY");

        setValue("created_at", a);

        setUpdated1(true);
      }
    }

    if (updatedDate != undefined && updatedDate !== "") {
      if (!updated2) {
        const a = Moment(updatedDate).format("DD/MM/YYYY");
        setValue("updated_at", a);

        setUpdated2(true);
      }
    }

    if (profileDob != undefined && profileDob !== "" && profileDob !== null) {
      if (!updated3) {
        if (profileDob.includes("GM")) {
          setValue("profile.dob", moment(profileDob).format("DD/MM/YYYY"));
        } else {
          const profileDate = profileDob
            .split("T")[0]
            .split("-")
            .reverse()
            .join("/");

          setValue("profile.dob", profileDate);
        }

        setUpdated3(true);
      }
    }

    if (profileDob == "Invalid date") {
      setValue("profile.dob", "");
    }

    let avatarData = getValues("avatar");

    if (avatarData != undefined) {
      if (!updated4) {
        setImageUrl(avatarData?.url);
        setUpdated4(true);
      }
    }
  }, [
    getValues("updated_at"),
    getValues("profile.dob"),
    getValues("created_at"),
    getValues("professionalRegistration.registrationDate.ts"),
    getValues("profile"),
  ]);

  const formValues = getValues();

  const roleFilter = formValues?.role?.name;

  const handleStatusChange = (e) => {
    const newStatus = e.target.value;
    const currentStatus = getValues("status");

    // ACTIVE -> INACTIVE
    if (currentStatus === "ACTIVE" && newStatus === "INACTIVE") {
      setPreviousStatus(currentStatus);
      setInactiveReason("");
      setStatusModalOpen(true);

      // IMPORTANT:
      // Abhi form status ko INACTIVE mat karo.
      // Reason submit hone ke baad hi status change hoga.
      return;
    }

    // INACTIVE -> ACTIVE
    setValue("status", newStatus);
  };

  // const calculateRows = (content) => {
  //   // Adjust these values according to your requirement
  //   const rowHeight = 24; // Height of each row in pixels
  //   const maxHeight = 200; // Maximum height in pixels

  //   // Calculate the number of rows based on content length
  //   const numRows = Math.min(Math.ceil(content.length / 40), Math.floor(maxHeight / rowHeight));

  //   return numRows;
  // };

  // const additionalSkillContent = responseData?.additionalSkill?.map(skill => skill.name).join(', ');
  // console.log("organizations>>", organizations)

  const currentDocuments = documents || [];
  const historyDocuments = values?.historyPreviousDocuments || [];
  const verifiedDocs = values?.verificationCertificate;
  // console.log("verifiedDocs>>", verifiedDocs);

  const professionalResumes = values?.professionalResume || [];
  // console.log("professionalResumes", professionalResumes)

  const groupedDocuments = {};

  // Current Documents
  currentDocuments.forEach((doc) => {
    const key = doc?.docType?.name;

    if (!key || key === "CV") {
      return;
    }

    if (!groupedDocuments[key]) {
      groupedDocuments[key] = [];
    }

    groupedDocuments[key].push({
      ...doc,
      isHistory: false,
    });
  });

  // console.log("groupedDocuments>>", groupedDocuments);

  // History Documents
  historyDocuments.forEach((doc) => {
    if (
      doc.docTypeName === "REGISTRATION" ||
      doc.docTypeName === "EDUCATION_CERTIFICATE"
    ) {
      if (!groupedDocuments[doc.docTypeName]) {
        groupedDocuments[doc.docTypeName] = [];
      }

      groupedDocuments[doc.docTypeName].push({
        ...doc,
        isHistory: true,
        docType: {
          name: doc.docTypeName,
        },
      });
    }
  });

  const formatDate = (value) => {
    if (!value) return "";
    if (/^\d+$/.test(value)) {
      const date = new Date(Number(value));
      const day = String(date.getUTCDate()).padStart(2, "0");
      const month = String(date.getUTCMonth() + 1).padStart(2, "0");
      const year = date.getUTCFullYear();
      return `${day}-${month}-${year}`;
    }
    return value.replace(/\//g, "-");
  };

  const DOC_TYPE_META = {
    REGISTRATION: { icon: BadgeIcon },
    EDUCATION_CERTIFICATE: { icon: SchoolIcon },
    EXPERIENCE_CERTIFICATE: { icon: WorkHistoryIcon },
    CV: { icon: ArticleIcon },
    AADHAR_CARD: { icon: CreditCardIcon },
    PAN: { icon: CreditCardIcon },
    PASSPORT: { icon: InsertDriveFileIcon },
    OTHER: { icon: DescriptionIcon },
  };

  // Old documents wala CV — fallback ke liye
  const fallbackCV = currentDocuments.find(
    (doc) => doc?.docType?.name === "CV",
  );

  // console.log("fallbackCV", fallbackCV)

  // Professional resumes available hain to unko use karo,
  // otherwise old documents CV ko default resume bana do.
  const resumeList =
    professionalResumes.length > 0
      ? professionalResumes
      : fallbackCV
        ? [
            {
              _id: fallbackCV?._id,
              manualResumeUrl:
                fallbackCV?.files?.url ||
                fallbackCV?.files?.uri ||
                fallbackCV?.files?.[0]?.url ||
                fallbackCV?.files?.[0]?.uri ||
                "",
              AIResumeUrl: null,
              resumeStatus: true,
              files: fallbackCV?.files,
              uploadedAt:
                fallbackCV?.uploadedAt ||
                fallbackCV?.createdAt ||
                Date.now().toString(),

              // fallback CV ko manually uploaded mark kar rahe hain
              resumeType: "MANUAL",
            },
          ]
        : [];

        // console.log("resumeList", resumeList);

  const sortedProfessionalResumes = [...resumeList].sort((a, b) => {
    // 1. Active resume first
    const aActive = a?.resumeStatus === true;
    const bActive = b?.resumeStatus === true;

    if (aActive && !bActive) return -1;
    if (!aActive && bActive) return 1;

    // 2. Same status -> latest uploadedAt first
    const aUploadedAt = Number(a?.uploadedAt || 0);
    const bUploadedAt = Number(b?.uploadedAt || 0);

    return bUploadedAt - aUploadedAt;
  });

  const ExpiryChip = ({ expiryDate }) => {
    if (!expiryDate) return null;
    const [day, month, year] = expiryDate.split("-").map(Number);
    const expiry = new Date(year, month - 1, day);
    const daysLeft = Math.ceil((expiry - new Date()) / (1000 * 60 * 60 * 24));
    let color = "success";
    let label = "Valid";
    if (daysLeft < 0) {
      color = "error";
      label = "Expired";
    } else if (daysLeft <= 30) {
      color = "warning";
      label = "Expiring soon";
    }
    return <Chip size="small" label={label} color={color} variant="outlined" />;
  };

  const getResumeType = (resume) => {
    // const type = String(
    //   resume?.type ||
    //     resume?.resumeType ||
    //     resume?.source ||
    //     resume?.createdBy ||
    //     "",
    // ).toUpperCase();

    // if (type.includes("AI")) {
    //   return "AI";
    // }

    // return "MANUAL";

    const AIResumeUrl = resume?.AIResumeUrl;
    const manualResumeUrl = resume?.manualResumeUrl;

    if (AIResumeUrl) {
      return "AI";
    }
    if (manualResumeUrl) {
      return "MANUAL";
    }
    return "MANUAL";
  };

  const getResumeUrl = (resume) => {
    return (
      resume?.file?.uri ||
      resume?.files?.[0]?.url ||
      resume?.url ||
      resume?.uri ||
      resume?.fileUrl ||
      resume?.files?.url ||
      resume?.AIResumeUrl ||
      resume?.manualResumeUrl ||
      ""
    );
  };

  const getResumeFileName = (resume, index) => {
    // const name =
    //   resume?.name ||
    //   resume?.title ||
    //   resume?.fileName ||
    //   `professional_resume_${index + 1}`;

    const AIResumeUrl = resume?.AIResumeUrl;
    const manualResumeUrl = resume?.manualResumeUrl;
    let name;
    if (AIResumeUrl) {
      name = "AI-Resume";
    }
    if (manualResumeUrl) {
      name = "Manual-Resume";
    }

    name = name || `professional_resume_${index + 1}`;

    return String(name)
      .replace(/\.[^/.]+$/, "")
      .replace(/[^a-zA-Z0-9-_]/g, "_");
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {formValues._id ? (
        <MDBox margin={4}>
          <Grid item xs={12}>
            <div style={{ display: "flex", width: "70px" }}>
              <Link onClick={handleBack}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  <ArrowBackIos fontSize="small" />
                  back
                </div>
              </Link>
            </div>
          </Grid>

          {/* Hospital Role */}

          {roleFilter == "HOSPITAL" ? (
            <form onSubmit={handleSubmit(onSubmit)}>
              <Grid container spacing={2}>
                <Grid item xs={3}>
                  <Typography variant="subtitle1">Full Name</Typography>
                </Grid>
                <Grid item xs={6}>
                  <MDInput
                    onKeyDown={(e) => {
                      e.key === "Enter" && e.preventDefault();
                    }}
                    fullWidth
                    sx={{ width: "100%", marginTop: "0.4rem" }}
                    inputProps={{
                      style: { fontSize: 15, fontWeight: "bold" },
                    }}
                    {...register("name.full")}
                    disabled
                  />
                </Grid>

                <Grid item xs={12}>
                  <Grid container spacing={3}>
                    <Grid item xs={4}>
                      {/* <Typography>ID: {ID}</Typography> */}
                      {/* <Grid container spacing={}> */}
                      {/* <Grid item xs={4}> */}
                      <Typography variant="subtitle1">ID: {ID}</Typography>
                      {/* </Grid> */}

                      {/* </Grid> */}
                    </Grid>
                    <Grid item xs={4}>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Controller
                              control={control}
                              {...register(`enabled`)}
                              render={({ field: props }) => (
                                <Checkbox
                                  {...props}
                                  checked={props.value}
                                  onChange={props.onChange}
                                />
                              )}
                            />
                          }
                          label="Enabled"
                        />
                      </FormGroup>
                    </Grid>
                    <Grid item xs={4}>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Controller
                              control={control}
                              {...register(`canAccessKeystone`)}
                              render={({ field: props }) => (
                                <Checkbox
                                  {...props}
                                  checked={props.value}
                                  onChange={props.onChange}
                                />
                              )}
                            />
                          }
                          label="Can Access Keystone?"
                        />
                      </FormGroup>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  {/* Company */}
                  <Grid item xs={12}>
                    <Paper sx={{ padding: "1rem" }}>
                      <Typography
                        variant="subtitle1"
                        style={{ fontWeight: 500 }}
                      >
                        Company
                      </Typography>
                      <hr style={{ marginBottom: "2rem" }} />
                      <ul style={{ listStyleType: "none" }}>
                        {organizations.map((field, index) => (
                          <li>
                            <Grid item xs={3}>
                              <Typography variant="subtitle1">
                                Company
                              </Typography>
                            </Grid>
                            <Grid item xs={9}>
                              <SelectDropDownNew
                                options={organizationOptions}
                                getValues={getValues}
                                control={control}
                                name={`organizations.[${index}].organization.name`}
                                customOnChange={(e) => {
                                  organizationOptions.map((elem) => {
                                    if (elem.value == e.target.value) {
                                      setValue(
                                        `organizations.[${index}].organization`,
                                        elem.key,
                                      );
                                    }
                                  });
                                }}
                              />
                            </Grid>

                            <Grid item xs={3}>
                              <Typography variant="subtitle1">Role</Typography>
                            </Grid>
                            <Grid item xs={9}>
                              <SelectDropDownNew
                                options={roleOptions}
                                getValues={getValues}
                                control={control}
                                name={`organizations.[${index}].role.name`}
                                customOnChange={(e) => {
                                  roleOptions.map((elem) => {
                                    if (elem.value == e.target.value) {
                                      setValue(
                                        `organizations.[${index}].role`,
                                        `${elem.key}`,
                                      );
                                    }
                                  });
                                }}
                              />
                            </Grid>

                            <Grid container columnSpacing={1}>
                              {/* isOwner flag */}
                              {/* isOwner flag – ONLY for first index */}
                              {index === 0 && (
                                <Grid item xs="auto">
                                  <FormGroup sx={{ m: 0 }}>
                                    <FormControlLabel
                                      sx={{ m: 0 }}
                                      control={
                                        <Controller
                                          defaultValue={false}
                                          control={control}
                                          name={`organizations.[${index}].isOwner`}
                                          // rules={{
                                          //   validate: (value) =>
                                          //     value === true ||
                                          //     "First organization must be Owner",
                                          // }}
                                          render={({ field, fieldState }) => (
                                            <>
                                              <Checkbox
                                                {...field}
                                                size="small"
                                                checked={field.value}
                                                onChange={(e) =>
                                                  field.onChange(
                                                    e.target.checked,
                                                  )
                                                }
                                              />
                                              {/* {fieldState.error && (
                                                <span
                                                  style={{
                                                    color: "red",
                                                    fontSize: "12px",
                                                  }}
                                                >
                                                  {fieldState.error.message}
                                                </span>
                                              )} */}
                                            </>
                                          )}
                                          // render={({ field }) => (
                                          //   <Checkbox
                                          //     {...field}
                                          //     size="small"
                                          //     checked={field.value}
                                          //     onChange={(e) =>
                                          //       field.onChange(e.target.checked)
                                          //     }
                                          //   />
                                          // )}
                                        />
                                      }
                                      label="IsOwner"
                                    />
                                  </FormGroup>
                                </Grid>
                              )}

                              {/* WhatsApp flag */}
                              <Grid item xs="auto">
                                <FormGroup sx={{ m: 0 }}>
                                  <FormControlLabel
                                    sx={{ m: 0 }}
                                    control={
                                      <Controller
                                        defaultValue={false}
                                        control={control}
                                        name={`organizations.[${index}].isWhatsappBotEnabled`}
                                        render={({ field }) => (
                                          <Checkbox
                                            {...field}
                                            size="small"
                                            checked={field.value}
                                            // onChange={(e) => {
                                            //   field.onChange(e.target.checked);
                                            //   setValue("orgIndex", index);
                                            // }}

                                            onChange={(e) =>
                                              field.onChange(e.target.checked)
                                            }
                                          />
                                        )}
                                      />
                                    }
                                    label="WhatsApp Bot"
                                  />
                                </FormGroup>
                              </Grid>
                            </Grid>

                            {/* <Grid item xs={12}>
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Controller
                                      defaultValue={false}
                                      control={control}
                                      name={`organizations.[${index}].isOwner`}
                                      render={({ field: props }) => (
                                        <Checkbox
                                          {...props}
                                          checked={props.value}
                                          onClick={(e) =>
                                            props.onChange(e.target.value)
                                          }
                                        />
                                      )}
                                    />
                                  }
                                  label="IsOwner"
                                />
                              </FormGroup>
                            </Grid> */}

                            <MDBox sx={{ textAlign: "right" }}>
                              <MDButton
                                variant="contained"
                                onClick={(e) => {
                                  e.preventDefault();
                                  companyRemove(index);
                                }}
                              >
                                <Typography color="error" variant="body">
                                  Remove
                                </Typography>
                              </MDButton>
                            </MDBox>
                            {/* </MDBox>  */}
                          </li>
                        ))}
                        <MDButton
                          variant="contained"
                          color="info"
                          onClick={(e) => {
                            companyAppend({});
                          }}
                        >
                          + Add
                        </MDButton>
                      </ul>
                    </Paper>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  {email.map((field, index) => (
                    <Grid container spacing={3}>
                      <Grid item xs={6}>
                        <Grid container>
                          <Grid item xs={3}>
                            <Typography variant="subtitle1">Email</Typography>
                          </Grid>
                          <Grid item xs={9}>
                            <MDInput
                              onKeyDown={(e) => {
                                e.key === "Enter" && e.preventDefault();
                              }}
                              fullWidth
                              disabled
                              {...register(`emails.[${index}].address`)}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={3}>
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Controller
                                control={control}
                                {...register(`emails.[${index}].isPrimary`)}
                                render={({ field: props }) => (
                                  <Checkbox
                                    {...props}
                                    checked={props.value}
                                    onChange={props.onChange}
                                  />
                                )}
                              />
                            }
                            label="Is Primary"
                          />
                        </FormGroup>
                      </Grid>
                      <Grid item xs={3}>
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Controller
                                control={control}
                                {...register(`emails.[${index}].isVerified`)}
                                render={({ field: props }) => (
                                  <Checkbox
                                    {...props}
                                    checked={props.value}
                                    onChange={props.onChange}
                                  />
                                )}
                              />
                            }
                            label="Is Verified"
                          />
                        </FormGroup>
                      </Grid>
                    </Grid>
                  ))}
                </Grid>
                <Grid item xs={12}>
                  {phone.map((field, index) => (
                    <Grid container spacing={3}>
                      <Grid item xs={6}>
                        <Grid container>
                          <Grid item xs={3}>
                            <Typography variant="subtitle1">
                              Phone Number
                            </Typography>
                          </Grid>

                          <Grid item xs={9}>
                            <MDInput
                              onKeyDown={(e) => {
                                e.key === "Enter" && e.preventDefault();
                              }}
                              fullWidth
                              disabled
                              {...register(`phoneNumbers.[${index}].number`)}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={3}>
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Controller
                                control={control}
                                {...register(
                                  `phoneNumbers.[${index}].isPrimary`,
                                )}
                                render={({ field: props }) => (
                                  <Checkbox
                                    {...props}
                                    checked={props.value}
                                    onChange={props.onChange}
                                  />
                                )}
                              />
                            }
                            label="Is Primary"
                          />
                        </FormGroup>
                      </Grid>
                      <Grid item xs={3}>
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Controller
                                control={control}
                                {...register(
                                  `phoneNumbers.[${index}].isVerified`,
                                )}
                                render={({ field: props }) => (
                                  <Checkbox
                                    {...props}
                                    checked={props.value}
                                    onChange={props.onChange}
                                  />
                                )}
                              />
                            }
                            label="Is Verified"
                          />
                        </FormGroup>
                      </Grid>
                    </Grid>
                  ))}
                </Grid>

                <Grid item xs={3}>
                  <Typography variant="subtitle1">Password</Typography>
                </Grid>
                <Grid item xs={9}>
                  <MDInput
                    onKeyDown={(e) => {
                      e.key === "Enter" && e.preventDefault();
                    }}
                    fullWidth
                    disabled
                    {...register("password")}
                  />
                </Grid>
                {/* Name Salutation */}
                <Grid item xs={3}>
                  <Typography variant="subtitle1">Name</Typography>
                </Grid>
                <Grid item xs={9}>
                  <Grid container spacing={4}>
                    <Grid item xs={3}>
                      <MDInput
                        onKeyDown={(e) => {
                          e.key === "Enter" && e.preventDefault();
                        }}
                        disabled
                        fullWidth
                        {...register("name.salutation")}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <MDInput
                        onKeyDown={(e) => {
                          e.key === "Enter" && e.preventDefault();
                        }}
                        disabled
                        fullWidth
                        {...register("name.first")}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <MDInput
                        onKeyDown={(e) => {
                          e.key === "Enter" && e.preventDefault();
                        }}
                        disabled
                        fullWidth
                        {...register("name.middle")}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <MDInput
                        onKeyDown={(e) => {
                          e.key === "Enter" && e.preventDefault();
                        }}
                        disabled
                        fullWidth
                        {...register("name.last")}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={3}>
                  <Typography variant="subtitle1">Organization Name</Typography>
                </Grid>
                <Grid item xs={9}>
                  <MDInput
                    onKeyDown={(e) => {
                      e.key === "Enter" && e.preventDefault();
                    }}
                    disabled
                    fullWidth
                    {...register("profile.organization.name")}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant="subtitle1">Organization Role</Typography>
                </Grid>
                <Grid item xs={9}>
                  <MDInput
                    onKeyDown={(e) => {
                      e.key === "Enter" && e.preventDefault();
                    }}
                    disabled
                    fullWidth
                    {...register("profile.organization.role")}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant="subtitle1">App Role</Typography>
                </Grid>
                <Grid item xs={9}>
                  <MDInput
                    onKeyDown={(e) => {
                      e.key === "Enter" && e.preventDefault();
                    }}
                    disabled
                    fullWidth
                    {...register("role.name")}
                  />
                </Grid>

                <Grid item xs={3}>
                  <Typography variant="subtitle1">Profile URL</Typography>
                </Grid>
                <Grid item xs={9}>
                  <MDInput
                    onKeyDown={(e) => {
                      e.key === "Enter" && e.preventDefault();
                    }}
                    // value={dob}
                    fullWidth
                    disabled
                    {...register("avatar.url")}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant="subtitle1">Created at</Typography>
                </Grid>
                <Grid item xs={9}>
                  <MDInput
                    onKeyDown={(e) => {
                      e.key === "Enter" && e.preventDefault();
                    }}
                    fullWidth
                    disabled
                    {...register("created_at")}
                  />
                </Grid>

                <Grid item xs={3}>
                  <Typography variant="subtitle1">Updated at</Typography>
                </Grid>
                <Grid item xs={9}>
                  <MDInput
                    onKeyDown={(e) => {
                      e.key === "Enter" && e.preventDefault();
                    }}
                    fullWidth
                    disabled
                    {...register("updated_at")}
                  />
                </Grid>

                <Grid item xs={3}>
                  <Typography variant="subtitle1">Created By</Typography>
                </Grid>
                <Grid item xs={9}>
                  <MDInput
                    onKeyDown={(e) => {
                      e.key === "Enter" && e.preventDefault();
                    }}
                    disabled
                    fullWidth
                    {...register("createdBy.name.full")}
                  />
                </Grid>

                <Grid item xs={3}>
                  <Typography variant="subtitle1">Updated By</Typography>
                </Grid>
                <Grid item xs={9}>
                  <MDInput
                    onKeyDown={(e) => {
                      e.key === "Enter" && e.preventDefault();
                    }}
                    fullWidth
                    disabled
                    {...register("updatedBy.name.full")}
                  />
                </Grid>

                <div style={{ marginTop: "2rem" }}>
                  <Button
                    type="submit"
                    variant="contained"
                    sx={{ color: "#fff" }}
                  >
                    Save
                  </Button>
                </div>
              </Grid>
            </form>
          ) : (
            <form onSubmit={handleSubmit(onSubmit)}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <MDInput
                    onKeyDown={(e) => {
                      e.key === "Enter" && e.preventDefault();
                    }}
                    placeholder=""
                    sx={{ width: "100%", marginTop: "0.4rem" }}
                    inputProps={{
                      style: { fontSize: 25, fontWeight: "bold" },
                    }}
                    {...register("name.full")}
                  />
                </Grid>
                <Grid item xs={12} sx={{ width: "100%", marginBottom: "20px" }}>
                  <Typography variant="subtitle1">ID: {ID}</Typography>
                  <Typography variant="subtitle1">
                    Candidate ID: {responseData?.candidateId}
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  {email.map((field, index) => (
                    <Grid container spacing={3}>
                      <Grid item xs={6}>
                        <Grid container>
                          <Grid item xs={3}>
                            <Typography variant="subtitle1">Email</Typography>
                          </Grid>
                          <Grid item xs={9}>
                            <MDInput
                              onKeyDown={(e) => {
                                e.key === "Enter" && e.preventDefault();
                              }}
                              fullWidth
                              disabled
                              {...register(`emails.[${index}].address`)}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={3}>
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Controller
                                control={control}
                                {...register(`emails.[${index}].isPrimary`)}
                                render={({ field: props }) => (
                                  <Checkbox
                                    {...props}
                                    checked={props.value}
                                    onChange={props.onChange}
                                  />
                                )}
                              />
                            }
                            label="Is Primary"
                          />
                        </FormGroup>
                      </Grid>
                      <Grid item xs={3}>
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Controller
                                control={control}
                                {...register(`emails.[${index}].isVerified`)}
                                render={({ field: props }) => (
                                  <Checkbox
                                    {...props}
                                    checked={props.value}
                                    onChange={props.onChange}
                                  />
                                )}
                              />
                            }
                            label="Is Verified"
                          />
                        </FormGroup>
                      </Grid>
                    </Grid>
                  ))}
                </Grid>
                <Grid item xs={12}>
                  {phone.map((field, index) => (
                    <Grid container spacing={3}>
                      <Grid item xs={6}>
                        <Grid container>
                          <Grid item xs={3}>
                            {index == 0 ? (
                              <Typography variant="subtitle1">
                                Phone Number
                              </Typography>
                            ) : (
                              <Typography variant="subtitle1">
                                Whatsapp Number
                              </Typography>
                            )}
                          </Grid>
                          <Grid item xs={9}>
                            <MDInput
                              onKeyDown={(e) => {
                                e.key === "Enter" && e.preventDefault();
                              }}
                              fullWidth
                              disabled
                              {...register(`phoneNumbers.[${index}].number`)}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={3}>
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Controller
                                control={control}
                                {...register(
                                  `phoneNumbers.[${index}].isPrimary`,
                                )}
                                render={({ field: props }) => (
                                  <Checkbox
                                    {...props}
                                    checked={props.value}
                                    onChange={props.onChange}
                                  />
                                )}
                              />
                            }
                            label="Is Primary"
                          />
                        </FormGroup>
                      </Grid>
                      <Grid item xs={3}>
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Controller
                                control={control}
                                {...register(
                                  `phoneNumbers.[${index}].isVerified`,
                                )}
                                render={({ field: props }) => (
                                  <Checkbox
                                    {...props}
                                    checked={props.value}
                                    onChange={props.onChange}
                                  />
                                )}
                              />
                            }
                            label="Is Verified"
                          />
                        </FormGroup>
                      </Grid>
                    </Grid>
                  ))}
                </Grid>

                {/* Password */}
                <Grid item xs={3}>
                  <Typography variant="subtitle1">Password</Typography>
                </Grid>
                <Grid item xs={9}>
                  <MDInput
                    onKeyDown={(e) => {
                      e.key === "Enter" && e.preventDefault();
                    }}
                    fullWidth
                    sx={{ width: "100%", marginTop: "0.4rem" }}
                    inputProps={{
                      style: { fontSize: 15, fontWeight: "bold" },
                    }}
                    {...register("password")}
                  />
                </Grid>
                {/* Name */}
                <Grid item xs={3}>
                  <Typography variant="subtitle1">Name</Typography>
                </Grid>
                <Grid item xs={9}>
                  <Grid container spacing={4}>
                    <Grid item xs={3}>
                      <MDInput
                        onKeyDown={(e) => {
                          e.key === "Enter" && e.preventDefault();
                        }}
                        sx={{ width: "100%", marginTop: "0.4rem" }}
                        inputProps={{
                          style: { fontSize: 15, fontWeight: "bold" },
                        }}
                        fullWidth
                        {...register("name.salutation")}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <MDInput
                        onKeyDown={(e) => {
                          e.key === "Enter" && e.preventDefault();
                        }}
                        sx={{ width: "100%", marginTop: "0.4rem" }}
                        inputProps={{
                          style: { fontSize: 15, fontWeight: "bold" },
                        }}
                        fullWidth
                        {...register("name.first")}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <MDInput
                        onKeyDown={(e) => {
                          e.key === "Enter" && e.preventDefault();
                        }}
                        sx={{ width: "100%", marginTop: "0.4rem" }}
                        inputProps={{
                          style: { fontSize: 15, fontWeight: "bold" },
                        }}
                        fullWidth
                        {...register("name.middle")}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <MDInput
                        onKeyDown={(e) => {
                          e.key === "Enter" && e.preventDefault();
                        }}
                        sx={{ width: "100%", marginTop: "0.4rem" }}
                        inputProps={{
                          style: { fontSize: 15, fontWeight: "bold" },
                        }}
                        fullWidth
                        {...register("name.last")}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={3}>
                  <Typography variant="subtitle1">Profile DOB</Typography>
                </Grid>
                <Grid item xs={9}>
                  <MDInput
                    onKeyDown={(e) => {
                      e.key === "Enter" && e.preventDefault();
                    }}
                    // value={dob}
                    // defaultValue={dob}
                    fullWidth
                    sx={{ width: "100%", marginTop: "0.4rem" }}
                    inputProps={{
                      style: { fontSize: 15, fontWeight: "bold" },
                    }}
                    {...register("profile.dob")}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant="subtitle1">
                    Currently Employed
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <MDInput
                    onKeyDown={(e) => {
                      e.key === "Enter" && e.preventDefault();
                    }}
                    fullWidth
                    sx={{ width: "100%", marginTop: "0.4rem" }}
                    inputProps={{
                      style: { fontSize: 15, fontWeight: "bold" },
                    }}
                    {...register("profile.currentlyEmployed")}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant="subtitle1">Profile Gender</Typography>
                </Grid>
                <Grid item xs={9}>
                  <MDInput
                    onKeyDown={(e) => {
                      e.key === "Enter" && e.preventDefault();
                    }}
                    fullWidth
                    sx={{ width: "100%", marginTop: "0.4rem" }}
                    inputProps={{
                      style: { fontSize: 15, fontWeight: "bold" },
                    }}
                    {...register("profile.gender")}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant="subtitle1">Profile Pan</Typography>
                </Grid>
                <Grid item xs={9}>
                  <MDInput
                    onKeyDown={(e) => {
                      e.key === "Enter" && e.preventDefault();
                    }}
                    fullWidth
                    sx={{ width: "100%", marginTop: "0.4rem" }}
                    inputProps={{
                      style: { fontSize: 15, fontWeight: "bold" },
                    }}
                    {...register("profile.pan")}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant="subtitle1">Profile Aadhar</Typography>
                </Grid>
                <Grid item xs={9}>
                  <MDInput
                    onKeyDown={(e) => {
                      e.key === "Enter" && e.preventDefault();
                    }}
                    fullWidth
                    sx={{ width: "100%", marginTop: "0.4rem" }}
                    inputProps={{
                      style: { fontSize: 15, fontWeight: "bold" },
                    }}
                    {...register("profile.aadhar")}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant="subtitle1">
                    Profile Social Facebook
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <MDInput
                    onKeyDown={(e) => {
                      e.key === "Enter" && e.preventDefault();
                    }}
                    fullWidth
                    sx={{ width: "100%", marginTop: "0.4rem" }}
                    inputProps={{
                      style: { fontSize: 15, fontWeight: "bold" },
                    }}
                    {...register("profile.social.facebook")}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant="subtitle1">
                    Profile Social Linkedin
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <MDInput
                    onKeyDown={(e) => {
                      e.key === "Enter" && e.preventDefault();
                    }}
                    fullWidthsx={{ width: "100%", marginTop: "0.4rem" }}
                    inputProps={{
                      style: { fontSize: 15, fontWeight: "bold" },
                    }}
                    {...register("profile.social.linkedin")}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant="subtitle1">Profile Covid</Typography>
                </Grid>
                <Grid item xs={9}>
                  <MDInput
                    onKeyDown={(e) => {
                      e.key === "Enter" && e.preventDefault();
                    }}
                    fullWidth
                    sx={{ width: "100%", marginTop: "0.4rem" }}
                    inputProps={{
                      style: { fontSize: 15, fontWeight: "bold" },
                    }}
                    {...register("profile.covid")}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Paper sx={{ padding: "1rem" }}>
                    <Typography variant="subtitle1" style={{ fontWeight: 500 }}>
                      Profile Job History
                    </Typography>
                    <hr style={{ marginBottom: "2rem" }} />
                    <ul style={{ listStyleType: "none" }}>
                      {profileJobHistory.map((field, index) => (
                        <li>
                          <Grid item xs={12}>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Controller
                                    name={`profile.jobHistory.[${index}].isCurrent`}
                                    control={control}
                                    render={({ field: props }) => (
                                      <Checkbox
                                        {...props}
                                        checked={props.value}
                                        {...register(
                                          `profile.jobHistory.[${index}].isCurrent`,
                                        )}
                                        onChange={(e) =>
                                          props.onChange(e.target.checked)
                                        }
                                      />
                                    )}
                                  />
                                }
                                label="Is Current?"
                              />
                            </FormGroup>
                          </Grid>
                          {/* Hospital */}
                          <Grid container item xs={12}>
                            <Grid item xs={3}>
                              <Typography variant="subtitle1">
                                Hospital
                              </Typography>
                            </Grid>
                            <Grid item xs={9}>
                              <MDInput
                                onKeyDown={(e) => {
                                  e.key === "Enter" && e.preventDefault();
                                }}
                                fullWidth
                                sx={{ width: "100%", marginTop: "0.4rem" }}
                                inputProps={{
                                  style: { fontSize: 15, fontWeight: "bold" },
                                }}
                                {...register(
                                  `profile.jobHistory.[${index}].hospital`,
                                )}
                              />
                            </Grid>
                          </Grid>
                          {/* Department */}
                          <Grid container item xs={12}>
                            <Grid item xs={3}>
                              <Typography variant="subtitle1">
                                Department
                              </Typography>
                            </Grid>
                            {/* <Grid item xs={9}>
                              <SelectDropDownNew
                                getValues={getValues}
                                control={control}
                                name={`profile.jobHistory.[${index}].department.name`}
                                defaultValue="none"
                                options={departmentTypeOption}
                                customOnChange={(e) => {
                                  departmentTypeOption.map((elem) => {
                                    if (elem?.value == e.target.value)
                                      setValue(
                                        `profile.jobHistory.[${index}].department`,
                                        elem?.key
                                      );
                                  });
                                }}
                              />
                            </Grid> */}
                            <Grid item xs={9}>
                              <MDInput
                                onKeyDown={(e) => {
                                  e.key === "Enter" && e.preventDefault();
                                }}
                                fullWidth
                                sx={{ width: "100%", marginTop: "0.4rem" }}
                                inputProps={{
                                  style: { fontSize: 15, fontWeight: "bold" },
                                }}
                                {...register(
                                  `profile.jobHistory.[${index}].department`,
                                )}
                              />
                            </Grid>
                          </Grid>
                          {/* Specialisation */}
                          <Grid container item xs={12}>
                            <Grid item xs={3}>
                              <Typography variant="subtitle1">
                                Specialization
                              </Typography>
                            </Grid>
                            {/* <Grid item xs={9}>
                              <SelectDropDownNew
                                getValues={getValues}
                                control={control}
                                name={`profile.jobHistory.[${index}].specialisation.name`}
                                defaultValue="none"
                                options={specializationOptions}
                                customOnChange={(e) => {
                                  specializationOptions.map((elem) => {
                                    if (elem?.value == e.target.value)
                                      setValue(
                                        `profile.jobHistory.[${index}].specialisation`,
                                        elem?.key
                                      );
                                  });
                                }}
                              />
                            </Grid> */}
                            <Grid item xs={9}>
                              <MDInput
                                onKeyDown={(e) => {
                                  e.key === "Enter" && e.preventDefault();
                                }}
                                fullWidth
                                sx={{ width: "100%", marginTop: "0.4rem" }}
                                inputProps={{
                                  style: { fontSize: 15, fontWeight: "bold" },
                                }}
                                {...register(
                                  `profile.jobHistory.[${index}].specialisation`,
                                )}
                              />
                            </Grid>
                          </Grid>

                          {/* start date */}
                          <Grid container item xs={12}>
                            <Grid item xs={4} sx={{ marginTop: "2rem" }}>
                              <Typography
                                variant="subtitle1"
                                sx={{ width: "80%", marginTop: "0.8rem" }}
                              >
                                Start
                              </Typography>
                            </Grid>

                            <Grid
                              xs={7}
                              sx={{
                                marginTop: "2rem",
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                              }}
                            >
                              <Grid item xs={7}>
                                <Controller
                                  name={`profile.jobHistory.[${index}].start`}
                                  control={control}
                                  render={({ field }) => (
                                    <LocalizationProvider
                                      dateAdapter={AdapterDayjs}
                                    >
                                      <DatePicker
                                        // minDate={new Date()}
                                        {...field}
                                        value={
                                          getValues(
                                            `profile.jobHistory.[${index}].start`,
                                          )
                                            ? getValues(
                                                `profile.jobHistory.[${index}].start`,
                                              )
                                            : null
                                        }
                                        inputProps={{
                                          style: {
                                            fontSize: 15,

                                            fontWeight: "bold",
                                          },
                                        }}
                                        {...register(
                                          `profile.jobHistory.[${index}].start`,
                                        )}
                                        onChange={(newValue) => {
                                          setValue(
                                            `profile.jobHistory.[${index}].start`,

                                            newValue.$d,
                                          );
                                          setValue(
                                            `profile.jobHistory.[${index}].end`,
                                            null,
                                          );
                                        }}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            onKeyDown={onKeyDown}
                                            autoComplete="off"
                                          />
                                        )}
                                      />
                                    </LocalizationProvider>
                                  )}
                                />
                              </Grid>
                              {/* <Grid item xs={3}>
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                >
                                  <TimePicker
                                    {...register(
                                      `profileJobHistory.[${index}].starttime`
                                    )}
                                    onChange={(newValue) => {
                                      setValue(newValue);
                                    }}
                                    renderInput={(params) => (
                                      <TextField {...params} />
                                    )}
                                  />
                                </LocalizationProvider>
                              </Grid>
                              <Grid item xs={3}>
                                <Button variant="contained">Now</Button>
                              </Grid> */}
                            </Grid>
                          </Grid>

                          {/* end date */}
                          <Grid container item xs={12}>
                            <Grid item xs={4} sx={{ marginTop: "2rem" }}>
                              <Typography
                                variant="subtitle1"
                                sx={{ width: "80%", marginTop: "0.8rem" }}
                              >
                                End
                              </Typography>
                            </Grid>

                            <Grid
                              xs={7}
                              sx={{
                                marginTop: "2rem",
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                              }}
                            >
                              <Grid item xs={5}>
                                <Controller
                                  name={`profile.jobHistory.[${index}].end`}
                                  control={control}
                                  render={({ field }) => (
                                    <LocalizationProvider
                                      dateAdapter={AdapterDayjs}
                                    >
                                      <DatePicker
                                        minDate={getValues(
                                          `profile.jobHistory.[${index}].start`,
                                        )}
                                        {...field}
                                        value={
                                          getValues(
                                            `profile.jobHistory.[${index}].end`,
                                          )
                                            ? getValues(
                                                `profile.jobHistory.[${index}].end`,
                                              )
                                            : null
                                        }
                                        inputProps={{
                                          style: {
                                            fontSize: 15,

                                            fontWeight: "bold",
                                          },
                                        }}
                                        {...register(
                                          `profile.jobHistory.[${index}].end`,
                                        )}
                                        onChange={(newValue) => {
                                          setValue(
                                            `profile.jobHistory.[${index}].end`,

                                            newValue.$d,
                                          );
                                        }}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            onKeyDown={onKeyDown}
                                            autoComplete="off"
                                          />
                                        )}
                                      />
                                    </LocalizationProvider>
                                  )}
                                />
                              </Grid>
                            </Grid>
                          </Grid>

                          {/* employee letter doc type */}
                          <Grid container item xs={12}>
                            <Grid item xs={3}>
                              <Typography variant="subtitle1">
                                Employee Letter Doc Type
                              </Typography>
                            </Grid>
                            <Grid item xs={9}>
                              <SelectDropDownNew
                                getValues={getValues}
                                control={control}
                                name={`profile.jobHistory.[${index}].employmentLetter.docType.name`}
                                options={documentTypeOptions}
                                defaultValue="none"
                                customOnChange={(e) => {
                                  handleDocTypeChange(
                                    e,
                                    `profile.jobHistory.[${index}].employmentLetter.docType`,
                                  );
                                }}
                              />
                            </Grid>
                          </Grid>
                          <Grid container item xs={12}>
                            <Grid item xs={9}>
                              <Typography variant="h6">
                                Employment Letter Files
                              </Typography>
                              <hr
                                style={{
                                  marginBottom: "2rem",
                                  marginTop: "1rem",
                                }}
                              />
                            </Grid>
                          </Grid>
                          <Grid item xs={9}>
                            <NestedArray1
                              setValue={setValue}
                              getValues={getValues}
                              nestIndex={index}
                              {...{ control, register }}
                            />
                          </Grid>

                          {/* employee letter uploaded at */}
                          <Grid container item xs={12}>
                            <Grid item xs={3}>
                              <Typography variant="subtitle1">
                                Employee Letter Uploaded At
                              </Typography>
                            </Grid>
                            <Grid item xs={9}>
                              <MDInput
                                onKeyDown={(e) => {
                                  e.key === "Enter" && e.preventDefault();
                                }}
                                fullWidth
                                {...register(
                                  `profile.jobHistory.[${index}].employmentLetter.uploadedAt`,
                                )}
                              />
                            </Grid>
                          </Grid>

                          {/* salary slip doc type */}
                          <Grid container item xs={12}>
                            <Grid item xs={3}>
                              <Typography variant="subtitle1">
                                Salary Slip Doc Type
                              </Typography>
                            </Grid>
                            <Grid item xs={9}>
                              <SelectDropDownNew
                                getValues={getValues}
                                control={control}
                                name={`profile.jobHistory.[${index}].salarySlip.docType.name`}
                                defaultValue="none"
                                options={docTypeOptions}
                                customOnChange={(e) => {
                                  docTypeOptions.map((elem) => {
                                    if (elem?.value == e.target.value)
                                      setValue(
                                        `profile.jobHistory.[${index}].salarySlip.docType`,
                                        `${elem.key}`,
                                      );
                                  });
                                }}
                              />
                            </Grid>
                          </Grid>

                          <Grid item xs={9}>
                            <Typography variant="h6">
                              Salary Slip Files
                            </Typography>
                            <hr
                              style={{
                                marginBottom: "2rem",
                                marginTop: "1rem",
                              }}
                            />
                          </Grid>

                          <Grid item xs={9}>
                            <NestedArray2
                              setValue={setValue}
                              getValues={getValues}
                              nestIndex={index}
                              {...{ control, register }}
                            />
                          </Grid>

                          {/* Salary Slip Uploaded At */}
                          <Grid container item xs={12}>
                            <Grid item xs={3}>
                              <Typography variant="subtitle1">
                                Salary Slip Uploaded At
                              </Typography>
                            </Grid>
                            <Grid item xs={9}>
                              <MDInput
                                onKeyDown={(e) => {
                                  e.key === "Enter" && e.preventDefault();
                                }}
                                fullWidth
                                {...register(
                                  `profile.jobHistory.[${index}].salarySlip.uploadedAt`,
                                )}
                              />
                            </Grid>
                          </Grid>

                          <MDBox sx={{ textAlign: "right" }}>
                            <MDButton
                              variant="contained"
                              onClick={(e) => {
                                e.preventDefault();
                                profileJobHistoryRemove(index);
                              }}
                            >
                              <Typography color="error" variant="body">
                                Remove
                              </Typography>
                            </MDButton>
                          </MDBox>
                          {/* </MDBox>  */}
                        </li>
                      ))}
                      <MDButton
                        variant="contained"
                        color="info"
                        onClick={(e) => {
                          profileJobHistoryAppend({});
                        }}
                      >
                        + Add
                      </MDButton>
                    </ul>
                  </Paper>
                </Grid>

                {/* profile education */}
                <Grid item xs={12}>
                  <Paper sx={{ padding: "1rem" }}>
                    <Typography variant="subtitle1" style={{ fontWeight: 500 }}>
                      Profile Education
                    </Typography>
                    <hr style={{ marginBottom: "2rem" }} />
                    <ul style={{ listStyleType: "none" }}>
                      {profileEducation.map((field, index) => {
                        return (
                          <li>
                            <Grid item xs={12}>
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Controller
                                      name={`profile.education.[${index}].isForeign`}
                                      control={control}
                                      render={({ field: props }) => (
                                        <Checkbox
                                          {...props}
                                          checked={props.value}
                                          {...register(
                                            `profile.education.[${index}].isForeign`,
                                          )}
                                          onChange={(e) =>
                                            props.onChange(e.target.checked)
                                          }
                                        />
                                      )}
                                    />
                                  }
                                  label="Is Foreign?"
                                />
                              </FormGroup>
                            </Grid>
                            {/* Course*/}
                            <Grid container item xs={12}>
                              <Grid item xs={3}>
                                <Typography variant="subtitle1">
                                  Course
                                </Typography>
                              </Grid>
                              <Grid item xs={9}>
                                <MDInput
                                  onKeyDown={(e) => {
                                    e.key === "Enter" && e.preventDefault();
                                  }}
                                  fullWidth
                                  sx={{ width: "100%", marginTop: "0.4rem" }}
                                  inputProps={{
                                    style: { fontSize: 15, fontWeight: "bold" },
                                  }}
                                  {...register(
                                    `profile.education.[${index}].course`,
                                  )}
                                />
                              </Grid>
                            </Grid>
                            {/* Specialisation*/}
                            <Grid container item xs={12}>
                              <Grid item xs={3}>
                                <Typography variant="subtitle1">
                                  Specialization
                                </Typography>
                              </Grid>
                              <Grid item xs={9}>
                                <SelectDropDownNew
                                  getValues={getValues}
                                  control={control}
                                  name={`profile.education.[${index}].specialisation.name`}
                                  defaultValue="none"
                                  options={specializationOptions}
                                  customOnChange={(e) => {
                                    handleSpecializationDynamic(
                                      e,
                                      `profile.education.[${index}].specialisation`,
                                    );
                                  }}
                                />
                              </Grid>
                            </Grid>
                            {/* Specialisation */}
                            <Grid container item xs={12}>
                              <Grid item xs={3}>
                                <Typography variant="subtitle1">
                                  Name
                                </Typography>
                              </Grid>
                              <Grid item xs={9}>
                                <MDInput
                                  onKeyDown={(e) => {
                                    e.key === "Enter" && e.preventDefault();
                                  }}
                                  fullWidth
                                  {...register(
                                    `profile.education.[${index}].name`,
                                  )}
                                />
                              </Grid>
                            </Grid>

                            {/* Year */}
                            <Grid container item xs={12}>
                              <Grid item xs={3}>
                                <Typography variant="subtitle1">
                                  Year
                                </Typography>
                              </Grid>
                              <Grid item xs={9}>
                                <MDInput
                                  onKeyDown={(e) => {
                                    e.key === "Enter" && e.preventDefault();
                                  }}
                                  fullWidth
                                  {...register(
                                    `profile.education.[${index}].year`,
                                  )}
                                />
                              </Grid>
                            </Grid>

                            {/* Certificate doc type */}
                            <Grid container item xs={12}>
                              <Grid item xs={3}>
                                <Typography variant="subtitle1">
                                  Certificate Doc Type
                                </Typography>
                              </Grid>
                              <Grid item xs={9}>
                                <SelectDropDownNew
                                  getValues={getValues}
                                  control={control}
                                  name={`profile.education.[${index}].certificate.docType.name`}
                                  defaultValue="none"
                                  options={documentTypeOptions}
                                  customOnChange={(e) => {
                                    handleDocTypeChange(
                                      e,
                                      `profile.education.[${index}].certificate.docType`,
                                    );
                                  }}
                                />
                              </Grid>
                            </Grid>

                            <Grid item xs={9}>
                              <Typography variant="h6">
                                Certificate Files
                              </Typography>
                              <hr
                                style={{
                                  marginBottom: "2rem",
                                  marginTop: "1rem",
                                }}
                              />
                            </Grid>

                            <Grid item xs={9}>
                              <NestedArray3
                                setValue={setValue}
                                getValues={getValues}
                                nestIndex={index}
                                {...{ control, register }}
                              />
                            </Grid>

                            {/* Certificate Uploaded At */}
                            <Grid container item xs={12}>
                              <Grid item xs={3}>
                                <Typography variant="subtitle1">
                                  Certificate Uploaded At
                                </Typography>
                              </Grid>
                              <Grid item xs={9}>
                                <MDInput
                                  onKeyDown={(e) => {
                                    e.key === "Enter" && e.preventDefault();
                                  }}
                                  fullWidth
                                  {...register(
                                    `profile.education.[${index}].certificate.uploadedAt`,
                                  )}
                                />
                              </Grid>
                            </Grid>

                            <MDBox sx={{ textAlign: "right" }}>
                              <MDButton
                                variant="contained"
                                onClick={(e) => {
                                  e.preventDefault();
                                  profileEducationRemove(index);
                                }}
                              >
                                <Typography color="error" variant="body">
                                  Remove
                                </Typography>
                              </MDButton>
                            </MDBox>
                            {/* </MDBox>  */}
                          </li>
                        );
                      })}
                      <MDButton
                        variant="contained"
                        color="info"
                        onClick={(e) => {
                          profileEducationAppend({});
                        }}
                      >
                        + Add
                      </MDButton>
                    </ul>
                  </Paper>
                </Grid>

                {/* profile refrence */}
                <Grid item xs={12}>
                  <Paper sx={{ padding: "1rem" }}>
                    <Typography variant="subtitle1" style={{ fontWeight: 500 }}>
                      Profile References
                    </Typography>
                    <hr style={{ marginBottom: "2rem" }} />
                    <ul style={{ listStyleType: "none" }}>
                      {profileRefrence.map((field, index) => (
                        <li>
                          {/* name*/}
                          <Grid item xs={3}>
                            <Typography variant="subtitle1">Name</Typography>
                          </Grid>
                          <Grid item xs={9}>
                            <MDInput
                              onKeyDown={(e) => {
                                e.key === "Enter" && e.preventDefault();
                              }}
                              fullWidth
                              sx={{ width: "100%", marginTop: "0.4rem" }}
                              inputProps={{
                                style: { fontSize: 15, fontWeight: "bold" },
                              }}
                              {...register(
                                `profile.references.[${index}].name`,
                              )}
                            />
                          </Grid>

                          {/* hospital*/}
                          <Grid item xs={3}>
                            <Typography variant="subtitle1">
                              Hospital
                            </Typography>
                          </Grid>
                          <Grid item xs={9}>
                            <MDInput
                              onKeyDown={(e) => {
                                e.key === "Enter" && e.preventDefault();
                              }}
                              fullWidth
                              sx={{ width: "100%", marginTop: "0.4rem" }}
                              inputProps={{
                                style: { fontSize: 15, fontWeight: "bold" },
                              }}
                              {...register(
                                `profile.references.[${index}].hospital`,
                              )}
                            />
                          </Grid>

                          {/* designation*/}
                          <Grid item xs={3}>
                            <Typography variant="subtitle1">
                              Designation
                            </Typography>
                          </Grid>
                          <Grid item xs={9}>
                            <MDInput
                              onKeyDown={(e) => {
                                e.key === "Enter" && e.preventDefault();
                              }}
                              fullWidth
                              sx={{ width: "100%", marginTop: "0.4rem" }}
                              inputProps={{
                                style: { fontSize: 15, fontWeight: "bold" },
                              }}
                              {...register(
                                `profile.references.[${index}].designation`,
                              )}
                            />
                          </Grid>

                          {/* phone*/}
                          <Grid item xs={3}>
                            <Typography variant="subtitle1">Phone</Typography>
                          </Grid>
                          <Grid item xs={9}>
                            <MDInput
                              onKeyDown={(e) => {
                                e.key === "Enter" && e.preventDefault();
                              }}
                              fullWidth
                              sx={{ width: "100%", marginTop: "0.4rem" }}
                              inputProps={{
                                style: { fontSize: 15, fontWeight: "bold" },
                              }}
                              {...register(
                                `profile.references.[${index}].phone`,
                              )}
                            />
                          </Grid>

                          {/*email*/}
                          <Grid item xs={3}>
                            <Typography variant="subtitle1">Email</Typography>
                          </Grid>
                          <Grid item xs={9}>
                            <MDInput
                              onKeyDown={(e) => {
                                e.key === "Enter" && e.preventDefault();
                              }}
                              fullWidth
                              sx={{ width: "100%", marginTop: "0.4rem" }}
                              inputProps={{
                                style: { fontSize: 15, fontWeight: "bold" },
                              }}
                              {...register(
                                `profile.references.[${index}].email`,
                              )}
                            />
                          </Grid>

                          <MDBox sx={{ textAlign: "right" }}>
                            <MDButton
                              variant="contained"
                              onClick={(e) => {
                                e.preventDefault();
                                profileRefrenceRemove(index);
                              }}
                            >
                              <Typography color="error" variant="body">
                                Remove
                              </Typography>
                            </MDButton>
                          </MDBox>
                          {/* </MDBox>  */}
                        </li>
                      ))}
                      <MDButton
                        variant="contained"
                        color="info"
                        onClick={(e) => {
                          profileRefrenceAppend({});
                        }}
                      >
                        + Add
                      </MDButton>
                    </ul>
                  </Paper>
                </Grid>

                {/* role */}

                <Grid item xs={3}>
                  <Typography variant="subtitle1">Role</Typography>
                </Grid>
                <Grid item xs={9}>
                  <SelectDropDownNew
                    getValues={getValues}
                    options={roleOptions}
                    control={control}
                    name={`role.name`}
                    defaultValue="none"
                    customOnChange={(e) => {
                      setValue(`role.name`, e.target.value);
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox defaultChecked />}
                      label="Can Access Keystone?"
                      sx={{ marginTop: "1rem" }}
                    />
                  </FormGroup>
                </Grid>

                {/* profile photo upload */}

                <Grid item xs={3}>
                  <Typography variant="subtitle1">
                    {imageUrl ? "Update Profile Photo" : "Upload Profile Photo"}
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={4}>
                      <div>
                        <input
                          type="file"
                          accept="image/*"
                          onChange={(e) => {
                            setImageUrl(URL.createObjectURL(e.target.files[0]));
                            setFile(e.target.files[0]);
                          }}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={5}>
                      {imageUrl && (
                        <div style={{ maxHeight: "40%", maxWidth: "50%" }}>
                          <CancelIcon
                            sx={{
                              position: "relative",
                              top: "1.8rem",
                              left: "90%",
                              color: "black",
                              cursor: "pointer",
                              marginBottom: "4px",
                              marginTop: "4px",
                            }}
                            onClick={() => {
                              setImageUrl(null);
                            }}
                          />{" "}
                          <img
                            src={imageUrl}
                            style={{
                              objectFit: "contain",
                              height: "70px",
                              width: "100px",
                              // marginLeft: "5px",
                            }}
                          />
                        </div>
                      )}
                    </Grid>
                  </Grid>
                  {/* <div> */}
                  {/* <input type="file" accept="image/*"  onChange={setFile}/>
                    <button>Upload</button> */}

                  {/* </div> */}
                </Grid>

                {/* Avatr Url */}
                {/* <Grid item xs={3}>
                  <Typography variant="subtitle1">Profile Photo Url</Typography>
                </Grid>
                <Grid item xs={9}>
                  <MDInput
                    fullWidth
                    sx={{ width: "100%", marginTop: "0.4rem" }}
                    inputProps={{
                      style: { fontSize: 15, fontWeight: "bold" },
                    }}
                    {...register("avatar.url")}
                  />
                </Grid> */}
                {/* secured */}
                <Grid item xs={12}>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Controller
                          control={control}
                          {...register(`avatar.isSecured`)}
                          render={({ field: props }) => (
                            <Checkbox
                              {...props}
                              checked={props.value}
                              onChange={props.onChange}
                            />
                          )}
                        />
                      }
                      label="Profile Photo Is Secured"
                    />
                  </FormGroup>
                </Grid>

                <Grid item xs={3}>
                  <Typography variant="subtitle1">Status</Typography>
                </Grid>
                <Grid item xs={9}>
                  <SelectDropDownNew
                    getValues={getValues}
                    options={statusOptions}
                    control={control}
                    name="status"
                    defaultValue={userObj?.status}
                    // customOnChange={(e) => {
                    //   setValue("status", e.target.value);
                    // }}
                    customOnChange={handleStatusChange}
                  />
                </Grid>

                {/* Documents */}

                {/* Documents */}

                <Grid item xs={12}>
                  <Paper sx={{ p: 3, borderRadius: 3 }}>
                    <Typography variant="h6" sx={{ mb: 3, fontWeight: 700 }}>
                      Documents
                    </Typography>

                    {/* ================= PROFESSIONAL RESUMES ================= */}

                    <Box sx={{ mb: 4 }}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          mb: 1.5,
                        }}
                      >
                        <ArticleIcon
                          fontSize="small"
                          sx={{ color: "text.secondary" }}
                        />

                        <Typography
                          variant="subtitle2"
                          sx={{
                            fontWeight: 700,
                            letterSpacing: 0.5,
                            textTransform: "uppercase",
                            color: "text.secondary",
                          }}
                        >
                          Professional Resumes
                        </Typography>
                      </Box>

                      <Divider sx={{ mb: 1.5 }} />

                      {sortedProfessionalResumes.length === 0 ? (
                        <Box
                          sx={{
                            py: 3,
                            px: 2,
                            textAlign: "center",
                            color: "text.secondary",
                          }}
                        >
                          <Typography variant="body2">
                            No professional resumes available.
                          </Typography>
                        </Box>
                      ) : (
                        sortedProfessionalResumes.map((resume, index) => {
                          // console.log("resume", resume);
                          const resumeUrl = getResumeUrl(resume);
                          console.log("resumeUrl", resumeUrl);
                          const resumeType = getResumeType(resume);
                          // console.log("resumeType", resumeType);

                          // const resumeStatus = String(
                          //   resume?.resumeStatus || "INACTIVE",
                          // ).toUpperCase();

                          const resumeStatus =
                            resume?.resumeStatus === true
                              ? "ACTIVE"
                              : "INACTIVE";

                          // console.log("resumeStatus", resumeStatus);

                          const isActive = resumeStatus === "ACTIVE";
                          // console.log("isActive", isActive)
                          const resumeName = getResumeFileName(resume, index);
                          // console.log("resumeName", resumeName);

                          const extension = resumeUrl
                            ? resumeUrl.split("?")[0].split(".").pop()
                            : "pdf";
                          console.log("extension", extension);
                          return (
                            <Box
                              key={resume?._id || index}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                py: 1.5,
                                px: 1.5,
                                borderRadius: 2,
                                transition: "background-color 0.15s ease",
                                "&:hover": {
                                  backgroundColor: "action.hover",
                                },
                                borderBottom:
                                  index !== sortedProfessionalResumes.length - 1
                                    ? "1px solid"
                                    : "none",
                                borderColor: "divider",
                              }}
                            >
                              {/* Resume Name */}
                              <Box
                                sx={{
                                  flex: "1 1 35%",
                                  minWidth: 0,
                                }}
                              >
                                <Typography
                                  fontWeight={600}
                                  noWrap
                                  title={
                                    // resumeName||
                                    "Professional Resume"
                                  }
                                >
                                  {
                                    // resumeName ||
                                    `Professional Resume ${index + 1}`
                                  }
                                </Typography>

                                {resume?.uploadedAt && (
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                  >
                                    UploadedAt:{" "}
                                    {formatDate(parseInt(resume.uploadedAt))}
                                  </Typography>
                                )}
                              </Box>

                              {/* Status */}
                              <Box
                                sx={{
                                  flex: "1 1 20%",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1,
                                }}
                              >
                                <Chip
                                  size="small"
                                  label={isActive ? "ACTIVE" : "INACTIVE"}
                                  color={isActive ? "success" : "default"}
                                  variant={isActive ? "filled" : "outlined"}
                                />
                              </Box>

                              {/* Resume Type */}
                              <Box
                                sx={{
                                  flex: "1 1 20%",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <Chip
                                  size="small"
                                  label={resumeType}
                                  color={
                                    resumeType === "AI" ? "primary" : "default"
                                  }
                                  variant="outlined"
                                />
                              </Box>

                              {/* Download */}
                              <Box
                                sx={{
                                  flex: "0 0 auto",
                                  textAlign: "center",
                                  pl: 2,
                                }}
                              >
                                {/* <Tooltip title="Download resume">
                                  <span>
                                    <IconButton
                                      size="small"
                                      disabled={!resumeUrl}
                                      onClick={(e) => {
                                        e.preventDefault();

                                        if (!resumeUrl) {
                                          return toast.error(
                                            "Resume file not available",
                                          );
                                        }

                                        handleDownload(
                                          `${resumeName}_${Date.now()}`,
                                          resumeUrl,
                                          extension,
                                        );
                                      }}
                                    >
                                      <FileDownloadIcon fontSize="small" />
                                    </IconButton>
                                  </span>
                                </Tooltip> */}
                                {/* Invoice + Receipt + Resume Download */}
                                <Box
                                  sx={{
                                    flex: "0 0 auto",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.5,
                                    pl: 2,
                                  }}
                                >
                                  {/* Invoice */}
                                  <Tooltip
                                    title={
                                      resume?.invoice?.invoiceUrl
                                        ? `Download Invoice ${
                                            resume?.invoice?.invoiceNumber || ""
                                          }`
                                        : "Invoice not available"
                                    }
                                  >
                                    <span>
                                      <IconButton
                                        size="small"
                                        disabled={!resume?.invoice?.invoiceUrl}
                                        onClick={(e) => {
                                          e.preventDefault();

                                          if (!resume?.invoice?.invoiceUrl) {
                                            return toast.error(
                                              "Invoice not available",
                                            );
                                          }

                                          handleDownload(
                                            resume?.invoice?.invoiceNumber ||
                                              `${resumeName}_Invoice`,
                                            resume.invoice.invoiceUrl,
                                            "pdf",
                                          );
                                        }}
                                      >
                                        <DescriptionIcon fontSize="small" />
                                      </IconButton>
                                    </span>
                                  </Tooltip>

                                  {/* Receipt */}
                                  <Tooltip
                                    title={
                                      resume?.receipt?.receiptUrl
                                        ? `Download Receipt ${
                                            resume?.receipt?.receiptNumber || ""
                                          }`
                                        : "Receipt not available"
                                    }
                                  >
                                    <span>
                                      <IconButton
                                        size="small"
                                        disabled={!resume?.receipt?.receiptUrl}
                                        onClick={(e) => {
                                          e.preventDefault();

                                          if (!resume?.receipt?.receiptUrl) {
                                            return toast.error(
                                              "Receipt not available",
                                            );
                                          }

                                          handleDownload(
                                            resume?.receipt?.receiptNumber ||
                                              `${resumeName}_Receipt`,
                                            resume.receipt.receiptUrl,
                                            "pdf",
                                          );
                                        }}
                                      >
                                        <ReceiptLongIcon fontSize="small" />
                                      </IconButton>
                                    </span>
                                  </Tooltip>

                                  {/* Resume Download */}
                                  <Tooltip title="Download resume">
                                    <span>
                                      <IconButton
                                        size="small"
                                        disabled={!resumeUrl}
                                        onClick={(e) => {
                                          e.preventDefault();

                                          if (!resumeUrl) {
                                            return toast.error(
                                              "Resume file not available",
                                            );
                                          }

                                          handleDownload(
                                            `${resumeName}_${Date.now()}`,
                                            resumeUrl,
                                            extension,
                                          );
                                        }}
                                      >
                                        <FileDownloadIcon fontSize="small" />
                                      </IconButton>
                                    </span>
                                  </Tooltip>
                                </Box>
                              </Box>
                            </Box>
                          );
                        })
                      )}
                    </Box>

                    {/* ================= OTHER DOCUMENTS ================= */}

                    {Object.entries(groupedDocuments).map(
                      ([docType, docs], groupIdx) => {
                        const meta = DOC_TYPE_META[docType] || {
                          icon: DescriptionIcon,
                        };

                        const Icon = meta.icon;

                        return (
                          <Box
                            key={docType}
                            sx={{
                              mb:
                                groupIdx ===
                                Object.keys(groupedDocuments).length - 1
                                  ? 0
                                  : 4,
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                mb: 1.5,
                              }}
                            >
                              <Icon
                                fontSize="small"
                                sx={{ color: "text.secondary" }}
                              />

                              <Typography
                                variant="subtitle2"
                                sx={{
                                  fontWeight: 700,
                                  letterSpacing: 0.5,
                                  textTransform: "uppercase",
                                  color: "text.secondary",
                                }}
                              >
                                {docType.replaceAll("_", " ")}
                              </Typography>
                            </Box>

                            <Divider sx={{ mb: 1.5 }} />

                            {docs.map((doc, index) => {
                              const startDate = doc.isHistory
                                ? doc?.registrationDate?.ts
                                : values?.professionalRegistration
                                    ?.registrationDate?.ts;

                              const endDate = doc.isHistory
                                ? doc?.expiryDate?.ts
                                : values?.professionalRegistration?.expiryDate
                                    ?.ts;

                              const formattedRegistrationDate =
                                formatDate(startDate);

                              const formattedExpiryDate = formatDate(endDate);

                              const displayName =
                                docType === "REGISTRATION"
                                  ? doc.isHistory
                                    ? `Previous Registration ${index}`
                                    : "Current Registration"
                                  : docType === "EDUCATION_CERTIFICATE"
                                    ? doc.isHistory
                                      ? `Previous Education Certificate ${index}`
                                      : "Current Education Certificate"
                                    : `Current ${docType.replaceAll("_", " ")}`;

                              return (
                                <Box
                                  key={doc?._id || index}
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    py: 1.5,
                                    px: 1.5,
                                    borderRadius: 2,
                                    transition: "background-color 0.15s ease",
                                    "&:hover": {
                                      backgroundColor: "action.hover",
                                    },
                                    borderBottom:
                                      index !== docs.length - 1
                                        ? "1px solid"
                                        : "none",
                                    borderColor: "divider",
                                  }}
                                >
                                  {/* Name */}
                                  <Box
                                    sx={{
                                      flex: "1 1 30%",
                                      minWidth: 0,
                                    }}
                                  >
                                    <Typography fontWeight={600} noWrap>
                                      {displayName}
                                    </Typography>
                                  </Box>

                                  {/* Registration date */}
                                  <Box sx={{ flex: "1 1 20%" }}>
                                    {docType === "REGISTRATION" && (
                                      <>
                                        <Typography
                                          variant="caption"
                                          color="text.secondary"
                                          display="block"
                                        >
                                          Registration Date
                                        </Typography>

                                        <Typography variant="body2">
                                          {formattedRegistrationDate || "-"}
                                        </Typography>
                                      </>
                                    )}
                                  </Box>

                                  {/* Expiry date + status */}
                                  <Box sx={{ flex: "1 1 25%" }}>
                                    {docType === "REGISTRATION" && (
                                      <>
                                        <Typography
                                          variant="caption"
                                          color="text.secondary"
                                          display="block"
                                        >
                                          Expiry Date
                                        </Typography>

                                        <Box
                                          sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 1,
                                          }}
                                        >
                                          <Typography variant="body2">
                                            {formattedExpiryDate || "-"}
                                          </Typography>

                                          <ExpiryChip
                                            expiryDate={formattedExpiryDate}
                                          />
                                        </Box>
                                      </>
                                    )}
                                  </Box>

                                  {/* Download */}
                                  <Box
                                    sx={{
                                      flex: "0 0 auto",
                                      textAlign: "center",
                                      pl: 2,
                                    }}
                                  >
                                    <Tooltip title="Download document">
                                      <IconButton
                                        size="small"
                                        onClick={(e) => {
                                          e.preventDefault();

                                          const URL = doc?.files?.[0]?.uri;

                                          if (!URL) {
                                            return toast.error(
                                              "Document file not available",
                                            );
                                          }

                                          const result = URL.split(".");
                                          const extension =
                                            result[result.length - 1];

                                          let expiryEndDate;
                                          let registrationDate;

                                          if (doc.isHistory) {
                                            expiryEndDate = doc?.expiryDate?.ts;

                                            registrationDate =
                                              doc?.registrationDate?.ts;
                                          } else {
                                            expiryEndDate =
                                              values?.professionalRegistration
                                                ?.expiryDate?.ts;

                                            registrationDate =
                                              values?.professionalRegistration
                                                ?.registrationDate?.ts;
                                          }

                                          const fExpiry =
                                            formatDate(expiryEndDate);

                                          const fRegistration =
                                            formatDate(registrationDate);

                                          const DOCTYPE = doc?.docType?.name;

                                          let downloadType;

                                          if (DOCTYPE === "REGISTRATION") {
                                            if (!fRegistration && !fExpiry) {
                                              return toast.error(
                                                "Registration certificate not available",
                                              );
                                            }

                                            downloadType = `registration_certificate_${fRegistration}_${fExpiry}`;
                                          } else {
                                            const documentNames = {
                                              EDUCATION_CERTIFICATE:
                                                "education_certificate",
                                              EXPERIENCE_CERTIFICATE:
                                                "experience_certificate",
                                              AADHAR_CARD: "aadhar_card",
                                              PAN: "pan_card",
                                              PASSPORT: "passport",
                                              OTHER: "other",
                                            };

                                            const documentName =
                                              documentNames[DOCTYPE] ||
                                              DOCTYPE.toLowerCase()
                                                .replace(/_/g, " ")
                                                .replace(/\b\w/g, (c) =>
                                                  c.toUpperCase(),
                                                )
                                                .replace(/ /g, "_");

                                            downloadType = `${documentName}_${Date.now()}`;
                                          }

                                          handleDownload(
                                            downloadType,
                                            URL,
                                            extension,
                                          );
                                        }}
                                      >
                                        <FileDownloadIcon fontSize="small" />
                                      </IconButton>
                                    </Tooltip>

                                    {/* Verified Certificate */}
                                    {docType === "REGISTRATION" && (
                                      <Tooltip title="Download Verified Certificate">
                                        <IconButton
                                          size="small"
                                          onClick={(e) => {
                                            e.preventDefault();

                                            const verifiedUrl = doc.isHistory
                                              ? doc?.verificationCertificate
                                                  ?.url
                                              : verifiedDocs;

                                            if (!verifiedUrl) {
                                              return toast.error(
                                                "Verified certificate not available",
                                              );
                                            }

                                            handleDownload(
                                              `verified_certificate_${Date.now()}`,
                                              verifiedUrl,
                                              "pdf",
                                            );
                                          }}
                                        >
                                          <VerifiedIcon
                                            fontSize="small"
                                            color="success"
                                          />
                                        </IconButton>
                                      </Tooltip>
                                    )}
                                  </Box>
                                </Box>
                              );
                            })}
                          </Box>
                        );
                      },
                    )}
                  </Paper>
                </Grid>

                {/* address address */}
                <Grid item xs={3}>
                  <Typography variant="subtitle1">Address Address</Typography>
                </Grid>
                <Grid item xs={9}>
                  <MDInput
                    onKeyDown={(e) => {
                      e.key === "Enter" && e.preventDefault();
                    }}
                    fullWidth
                    sx={{ width: "100%", marginTop: "0.4rem" }}
                    inputProps={{
                      style: { fontSize: 15, fontWeight: "bold" },
                    }}
                    {...register("address.address")}
                  />
                </Grid>
                {/* address city */}
                <Grid item xs={3}>
                  <Typography variant="subtitle1">Address City</Typography>
                </Grid>
                <Grid item xs={9}>
                  <MDInput
                    onKeyDown={(e) => {
                      e.key === "Enter" && e.preventDefault();
                    }}
                    fullWidth
                    sx={{ width: "100%", marginTop: "0.4rem" }}
                    inputProps={{
                      style: { fontSize: 15, fontWeight: "bold" },
                    }}
                    {...register("address.city")}
                  />
                </Grid>
                {/* address state */}
                <Grid item xs={3}>
                  <Typography variant="subtitle1">Address State</Typography>
                </Grid>
                <Grid item xs={9}>
                  <MDInput
                    onKeyDown={(e) => {
                      e.key === "Enter" && e.preventDefault();
                    }}
                    fullWidth
                    sx={{ width: "100%", marginTop: "0.4rem" }}
                    inputProps={{
                      style: { fontSize: 15, fontWeight: "bold" },
                    }}
                    {...register("address.state")}
                  />
                </Grid>
                {/* address pin */}
                <Grid item xs={3}>
                  <Typography variant="subtitle1">Address Pin</Typography>
                </Grid>
                <Grid item xs={9}>
                  <MDInput
                    onKeyDown={(e) => {
                      e.key === "Enter" && e.preventDefault();
                    }}
                    fullWidth
                    sx={{ width: "100%", marginTop: "0.4rem" }}
                    inputProps={{
                      style: { fontSize: 15, fontWeight: "bold" },
                    }}
                    {...register("address.pin")}
                  />
                </Grid>
                {/* address country */}
                <Grid item xs={3}>
                  <Typography variant="subtitle1">Address Country</Typography>
                </Grid>
                <Grid item xs={9}>
                  <MDInput
                    onKeyDown={(e) => {
                      e.key === "Enter" && e.preventDefault();
                    }}
                    fullWidth
                    sx={{ width: "100%", marginTop: "0.4rem" }}
                    inputProps={{
                      style: { fontSize: 15, fontWeight: "bold" },
                    }}
                    {...register("address.country")}
                  />
                </Grid>

                {/* test paper attempts */}
                <Grid item xs={3}>
                  <Typography variant="subtitle1">
                    Test Paper Attempts
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <SelectDropDown
                    disabled
                    options={selectOptions}
                    control={control}
                    name={`testPaperAttempts`}
                    defaultValue="none"
                    customOnChange={(e) => {
                      setValue("testPaperAttempts", e.target.value);
                    }}
                  />
                </Grid>

                {/* Qualification */}
                <Grid item xs={3}>
                  <Typography variant="subtitle1">Qualification</Typography>
                </Grid>
                <Grid item xs={9}>
                  <SelectDropDownNew
                    getValues={getValues}
                    options={qualificationOptions}
                    control={control}
                    name={`qualification.name`}
                    defaultValue="none"
                    customOnChange={handleQualification}
                  />
                </Grid>

                {/* Num Experience */}
                <Grid item xs={3}>
                  <Typography variant="subtitle1">Num Experience</Typography>
                </Grid>
                <Grid item xs={9}>
                  <SelectDropDownNew
                    getValues={getValues}
                    options={experienceOptions}
                    control={control}
                    name={`numExperience.name`}
                    defaultValue="none"
                    customOnChange={handleExperience}
                  />
                </Grid>

                {/* Professionsla Registration Number */}
                <Grid item xs={3}>
                  <Typography variant="subtitle1">
                    Professional Registration Number
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <MDInput
                    onKeyDown={(e) => {
                      e.key === "Enter" && e.preventDefault();
                    }}
                    fullWidth
                    sx={{ width: "100%", marginTop: "0.4rem" }}
                    inputProps={{
                      style: { fontSize: 15, fontWeight: "bold" },
                    }}
                    {...register("professionalRegistration.number")}
                  />
                </Grid>
                {/* Professionsla Registration registration date Year */}
                <Grid item xs={3}>
                  <Typography variant="subtitle1">
                    Professional Registration Registration Date
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Grid container spacing={4}>
                    <Grid item xs={3}>
                      <MDInput
                        disabled
                        fullWidth
                        {...register(
                          "professionalRegistration.registrationDate.year",
                        )}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <MDInput
                        disabled
                        fullWidth
                        {...register(
                          "professionalRegistration.registrationDate.month",
                        )}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <MDInput
                        disabled
                        fullWidth
                        {...register(
                          "professionalRegistration.registrationDate.date",
                        )}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <MDInput
                        disabled
                        fullWidth
                        {...register(
                          "professionalRegistration.registrationDate.ts",
                        )}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {/* Professionsla Registration expiry date Year */}
                <Grid item xs={3}>
                  <Typography variant="subtitle1">
                    Professional Registration Expiry Date
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Grid container spacing={4}>
                    <Grid item xs={3}>
                      <MDInput
                        disabled
                        fullWidth
                        {...register(
                          "professionalRegistration.expiryDate.year",
                        )}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <MDInput
                        disabled
                        fullWidth
                        {...register(
                          "professionalRegistration.expiryDate.month",
                        )}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <MDInput
                        disabled
                        fullWidth
                        {...register(
                          "professionalRegistration.expiryDate.date",
                        )}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <MDInput
                        disabled
                        fullWidth
                        {...register("professionalRegistration.expiryDate.ts")}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {/* /Professional Registartion Registartion Type */}
                <Grid item xs={3}>
                  <Typography variant="subtitle1">
                    Professional Registration Registration Type
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <SelectDropDownNew
                    getValues={getValues}
                    options={professionalRegistrationTypeOptions}
                    control={control}
                    name={`professionalRegistration.registrationType.name`}
                    defaultValue="none"
                    customOnChange={handleProfessionalReg}
                  />
                </Grid>

                <Grid item xs={3}>
                  <Typography variant="subtitle1">
                    Registration State
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <MDInput
                    onKeyDown={(e) => {
                      e.key === "Enter" && e.preventDefault();
                    }}
                    disabled={true}
                    fullWidth
                    sx={{ width: "100%", marginTop: "0.4rem" }}
                    inputProps={{
                      style: { fontSize: 15, fontWeight: "bold" },
                    }}
                    {...register("professionalRegistration.registrationState")}
                  />
                </Grid>
                {/* Professional Type */}
                <Grid item xs={3}>
                  <Typography variant="subtitle1">Professional Type</Typography>
                </Grid>
                <Grid item xs={9}>
                  <SelectDropDownNew
                    getValues={getValues}
                    options={professionOptions}
                    control={control}
                    name={`professionalType.name`}
                    defaultValue="none"
                    customOnChange={handleProfessionalType}
                  />
                </Grid>
                {/* Specialization */}
                <Grid item xs={3}>
                  <Typography variant="subtitle1">Specialization</Typography>
                </Grid>
                <Grid item xs={9}>
                  <SelectDropDownNew
                    getValues={getValues}
                    options={specializationOptions}
                    control={control}
                    name={`specialization.name`}
                    customOnChange={handleSpecialization}
                  />
                </Grid>
                {/* Departments  */}
                <Grid item xs={3}>
                  <Typography variant="subtitle1">Departments</Typography>
                </Grid>
                <Grid item xs={9}>
                  <MultiSelectDropdown
                    options={departmentTypeOption}
                    getValues={getValues}
                    name="departments"
                    setValue={setValue}
                    control={control}
                    customOnChange={handleDepartmentMultiSelect}
                  />
                  {/* <SelectDropDownNew
                    setValue={setValue}
                    getValues={getValues}
                    options={departmentTypeOption}
                    control={control}
                    name={"departments[0].name"}
                    defaultValue="none"
                    customOnChange={handleDepartments}
                  /> */}
                </Grid>

                {/* work city */}
                <Grid item xs={3}>
                  <Typography variant="subtitle1">Work City</Typography>
                </Grid>
                <Grid item xs={9}>
                  <SelectDropDownNew
                    getValues={getValues}
                    options={cityOptions}
                    control={control}
                    name={`workCity.name`}
                    defaultValue="none"
                    customOnChange={handleWorkCity}
                  />
                </Grid>

                {/* Language Known */}
                <Grid item xs={3}>
                  <Typography variant="subtitle1">Language Known</Typography>
                </Grid>
                <Grid item xs={9}>
                  {/* <SelectDropDownNew
                    getValues={getValues}
                    options={languageOptions}
                    control={control}
                    name={`languageKnown[0].name`}
                    defaultValue="none"
                    customOnChange={handleLanguage}
                  /> */}
                  {/* <MultiSelectDropdown
                    options={languageOptions}
                    getValues={getValues}
                    name={`languageKnown`}
                    setValue={setValue}
                    control={control}
                    customOnChange={handleLanguageKnown}
                  /> */}
                  <MDInput
                    multiline
                    rows={2}
                    onKeyDown={(e) => {
                      e.key === "Enter" && e.preventDefault();
                    }}
                    fullWidth
                    sx={{ width: "100%", marginTop: "0.4rem" }}
                    inputProps={{
                      style: { fontSize: 15, fontWeight: "bold" },
                    }}
                    {...register(
                      // `languageKnown`
                      `languageKnownNew`,
                    )}
                  />
                </Grid>
                {/* Wokeen on */}
                <Grid item xs={3}>
                  <Typography variant="subtitle1">Worked On</Typography>
                </Grid>
                <Grid item xs={9}>
                  <MultiSelectDropdown
                    options={workedonOptions}
                    getValues={getValues}
                    name="workedOn"
                    setValue={setValue}
                    control={control}
                    customOnChange={handleWorked}
                  />
                </Grid>
                {/* Additional Training */}
                <Grid item xs={3}>
                  <Typography variant="subtitle1">
                    Additional Training
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  {/* <MultiSelectDropdown
                    options={additionalTrainingOptions}
                    getValues={getValues}
                    name="additionalTraining"
                    setValue={setValue}
                    control={control}
                    customOnChange={handleAdditionalTraining}
                  /> */}

                  <MDInput
                    multiline
                    rows={3}
                    onKeyDown={(e) => {
                      e.key === "Enter" && e.preventDefault();
                    }}
                    fullWidth
                    sx={{ width: "100%", marginTop: "0.4rem" }}
                    inputProps={{
                      style: { fontSize: 15, fontWeight: "bold" },
                    }}
                    {...register(
                      // "additionalTraining"
                      `additionalTrainingNew`,
                    )}
                  />
                </Grid>

                {/* Additional Skills */}
                <Grid item xs={3}>
                  <Typography variant="subtitle1">Additional Skill</Typography>
                </Grid>
                <Grid item xs={9}>
                  <MDInput
                    multiline
                    rows={3}
                    // multiline
                    // rows={calculateRows(additionalSkillContent)}
                    onKeyDown={(e) => {
                      e.key === "Enter" && e.preventDefault();
                    }}
                    fullWidth
                    sx={{ width: "100%", marginTop: "0.4rem" }}
                    inputProps={{
                      // rows: 6,
                      style: { fontSize: 15, fontWeight: "bold" },
                    }}
                    value={responseData?.additionalSkill
                      .map((skill) => skill.name)
                      .join(", ")}
                    // value={additionalSkillContent}
                    // {...register(
                    //   // "additionalTraining"
                    //   `additionalTrainingNew[0]`
                    // )}
                  />
                </Grid>

                <Grid item xs={3}>
                  <Typography variant="subtitle1">
                    Bank Detail Benificiary Name
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <MDInput
                    onKeyDown={(e) => {
                      e.key === "Enter" && e.preventDefault();
                    }}
                    fullWidth
                    sx={{ width: "100%", marginTop: "0.4rem" }}
                    inputProps={{
                      style: { fontSize: 15, fontWeight: "bold" },
                    }}
                    {...register("bankDetails.beneficiaryName")}
                  />
                </Grid>

                <Grid item xs={3}>
                  <Typography variant="subtitle1">
                    Bank Detail Account Number
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <MDInput
                    onKeyDown={(e) => {
                      e.key === "Enter" && e.preventDefault();
                    }}
                    fullWidth
                    sx={{ width: "100%", marginTop: "0.4rem" }}
                    inputProps={{
                      style: { fontSize: 15, fontWeight: "bold" },
                    }}
                    {...register("bankDetails.accountNumber")}
                  />
                </Grid>

                <Grid item xs={3}>
                  <Typography variant="subtitle1">Bank Detail IFSC</Typography>
                </Grid>
                <Grid item xs={9}>
                  <MDInput
                    onKeyDown={(e) => {
                      e.key === "Enter" && e.preventDefault();
                    }}
                    fullWidth
                    sx={{ width: "100%", marginTop: "0.4rem" }}
                    inputProps={{
                      style: { fontSize: 15, fontWeight: "bold" },
                    }}
                    {...register("bankDetails.ifsc")}
                  />
                </Grid>

                <Grid item xs={3}>
                  <Typography variant="subtitle1">
                    Bank Detail Bank Name
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <MDInput
                    onKeyDown={(e) => {
                      e.key === "Enter" && e.preventDefault();
                    }}
                    fullWidth
                    sx={{ width: "100%", marginTop: "0.4rem" }}
                    inputProps={{
                      style: { fontSize: 15, fontWeight: "bold" },
                    }}
                    {...register("bankDetails.bankName")}
                  />
                </Grid>

                <Grid item xs={3}>
                  <Typography variant="subtitle1">
                    Bank Detail Branch Address
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <MDInput
                    onKeyDown={(e) => {
                      e.key === "Enter" && e.preventDefault();
                    }}
                    fullWidth
                    {...register("bankDetails.branchAddress")}
                  />
                </Grid>

                {/* isPremium */}
                <Grid item xs={3} sx={{ marginTop: "0.4rem" }}>
                  <Typography
                    variant="subtitle1"
                    sx={{ width: "50%", marginTop: "0.4rem" }}
                  >
                    IsPremium
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <MDInput
                    onKeyDown={(e) => {
                      e.key === "Enter" && e.preventDefault();
                    }}
                    placeholder="IsPremium"
                    sx={{ width: "100%", marginTop: "0.4rem" }}
                    inputProps={{
                      style: { fontSize: 15, fontWeight: "bold" },
                    }}
                    // {...register("postedBy")}
                    value={responseData?.isPremium ? "True" : "False"}
                  />
                </Grid>

                <Grid item xs={3}>
                  <Typography variant="subtitle1">Created at</Typography>
                </Grid>
                <Grid item xs={9}>
                  <MDInput
                    fullWidth
                    disabled
                    sx={{ width: "100%", marginTop: "0.4rem" }}
                    inputProps={{
                      style: { fontSize: 15, fontWeight: "bold" },
                    }}
                    {...register("created_at")}
                  />
                </Grid>

                <Grid item xs={3}>
                  <Typography variant="subtitle1">Updated at</Typography>
                </Grid>
                <Grid item xs={9}>
                  <MDInput
                    fullWidth
                    disabled
                    sx={{ width: "100%", marginTop: "0.4rem" }}
                    inputProps={{
                      style: { fontSize: 15, fontWeight: "bold" },
                    }}
                    {...register("updated_at")}
                  />
                </Grid>

                <Grid item xs={3}>
                  <Typography variant="subtitle1">Created By</Typography>
                </Grid>
                <Grid item xs={9}>
                  <MDInput
                    fullWidth
                    sx={{ width: "100%", marginTop: "0.4rem" }}
                    inputProps={{
                      style: { fontSize: 15, fontWeight: "bold" },
                    }}
                    disabled
                    {...register("createdBy.name.full")}
                  />
                </Grid>

                <Grid item xs={3}>
                  <Typography variant="subtitle1">Updated By</Typography>
                </Grid>
                <Grid item xs={9}>
                  <MDInput
                    fullWidth
                    sx={{ width: "100%", marginTop: "0.4rem" }}
                    inputProps={{
                      style: { fontSize: 15, fontWeight: "bold" },
                    }}
                    disabled
                    {...register("updatedBy.name.full")}
                  />
                </Grid>
                {/* testing  */}
                <div style={{ marginTop: "2rem" }}>
                  <Button
                    type="submit"
                    variant="contained"
                    sx={{ color: "#fff" }}
                  >
                    Save
                  </Button>
                </div>
              </Grid>
            </form>
          )}
        </MDBox>
      ) : (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "24%",
            marginTop: "20%",
          }}
        >
          <CircularProgress disableShrink />
        </div>
      )}

      <Dialog
        open={statusModalOpen}
        onClose={() => {
          setStatusModalOpen(false);
          setInactiveReason("");
          setValue("status", previousStatus);
        }}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: {
            borderRadius: "10px",
            overflow: "hidden",
            boxShadow: "0 10px 40px rgba(0, 0, 0, 0.25)",
          },
        }}
      >
        {/* Header */}
        <DialogTitle
          sx={{
            px: 3,
            pt: 3,
            pb: 1.5,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.5,
            }}
          >
            {/* Warning Icon */}
            <Box
              sx={{
                width: 42,
                height: 42,
                borderRadius: "50%",
                border: "2px solid #ef5350",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#ef5350",
              }}
            >
              <WarningAmberRoundedIcon />
            </Box>

            <Typography
              sx={{
                fontSize: "22px",
                fontWeight: 700,
                color: "#243b5a",
              }}
            >
              Deactivate User
            </Typography>
          </Box>

          {/* Close */}
          <IconButton
            onClick={() => {
              setStatusModalOpen(false);
              setInactiveReason("");
              setValue("status", previousStatus);
            }}
            sx={{
              color: "#777",
              "&:hover": {
                backgroundColor: "#f5f5f5",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        {/* Content */}
        <DialogContent
          sx={{
            px: 3,
            pt: "8px !important",
            pb: 3,
          }}
        >
          <Typography
            sx={{
              fontSize: "15px",
              color: "#666",
              mb: 2.5,
            }}
          >
            Please provide a reason for deactivating this user.
          </Typography>

          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: 500,
              color: "#333",
              mb: 0.8,
            }}
          >
            Reason <span style={{ color: "#d32f2f" }}>*</span>
          </Typography>

          <TextField
            fullWidth
            multiline
            minRows={5}
            maxRows={8}
            placeholder="Enter reason for deactivation..."
            value={inactiveReason}
            onChange={(e) => {
              setInactiveReason(e.target.value);
            }}
            autoFocus
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "7px",

                "& textarea": {
                  fontSize: "15px",
                },

                "& fieldset": {
                  borderColor: "#bdbdbd",
                },

                "&:hover fieldset": {
                  borderColor: "#757575",
                },

                "&.Mui-focused fieldset": {
                  borderColor: "#1565c0",
                  borderWidth: "2px",
                },
              },
            }}
          />

          {/* Validation */}
          {!inactiveReason.trim() && (
            <Typography
              sx={{
                color: "#d32f2f",
                fontSize: "12px",
                mt: 0.8,
              }}
            >
              Reason is required to deactivate the user.
            </Typography>
          )}
        </DialogContent>

        {/* Footer */}
        <DialogActions
          sx={{
            px: 3,
            py: 2,
            borderTop: "1px solid #eeeeee",
            gap: 1.5,
          }}
        >
          {/* Cancel */}
          <Button
            onClick={() => {
              setStatusModalOpen(false);
              setInactiveReason("");
              setValue("status", previousStatus);
            }}
            sx={{
              minWidth: "100px",
              height: "44px",
              borderRadius: "7px",
              color: "#5f6b82",
              fontWeight: 700,
              fontSize: "13px",
              textTransform: "uppercase",
              border: "1px solid transparent",

              "&:hover": {
                backgroundColor: "#f5f5f5",
              },
            }}
          >
            Cancel
          </Button>

          {/* Deactivate */}
          <Button
            variant="contained"
            disabled={!inactiveReason.trim()}
            startIcon={<PersonOffOutlinedIcon />}
            onClick={() => {
              const reason = inactiveReason.trim();

              if (!reason) {
                return;
              }

              // Set status
              setValue("status", "INACTIVE");

              // Set reason for payload
              setValue("inactiveReason", reason);

              // Close modal
              setStatusModalOpen(false);
              setInactiveReason("");
            }}
            sx={{
              minWidth: "180px",
              height: "44px",
              borderRadius: "7px",
              fontWeight: 700,
              fontSize: "13px",
              textTransform: "none",

              backgroundColor: "#e53935",

              "&:hover": {
                backgroundColor: "#c62828",
              },

              "&.Mui-disabled": {
                backgroundColor: "#e0e0e0",
                color: "#9e9e9e",
              },
            }}
          >
            Deactivate User
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default UserDetailByName;
